{
  "cookies": {
      "terms": {
      "cookies": {
        "header": "Spis treści",
        "subheader": "Kliknij poniżej, aby przejść do wybranej sekcji.",
        "list": [
          {
            "heading": "",
            "link": "about",
            "content": "Serwisy internetowe oraz aplikacje Benefit Systems S.A. (dalej: <b>„Benefit Systems”</b> lub <b>„my”</b>) wykorzystują \n pliki cookies i podobne technologie.\n <br>\n <br>\nPoniżej znajdziesz informacje o plikach cookies i podobnych technologiach, jakie wykorzystujemy oraz dodatkowe informacje dotyczące sposobu działania naszych serwisów i aplikacji, w tym informacje o Local Storage, komunikatach push i wykorzystywaniu lokalizacji. "
          },
          {
            "heading": "Czym są pliki cookies?",
            "link": "cookies",
            "content": "Pliki cookies, czyli inaczej „ciasteczka” to pliki tekstowe zapisywane na Twoim urządzeniu (np. komputerze, laptopie, smartfonie), gdy przeglądasz Internet. <br><br>Przy ponownych odwiedzinach stron internetowych Benefit Systems, przeglądarka wysyła pliki cookies z powrotem do serwisu (a dokładniej, do jego serwera). W ten sposób możemy pozyskiwać informacje o aktywności użytkownika, np. rozpoznawać kiedy ponownie nas odwiedza.  <br><br>Pliki cookies mają swój okres ważności, po upływie którego stają się nieaktywne. W naszych serwisach i aplikacjach wykorzystujemy także inne podobne technologie takie jak piksele, wtyczki, tagi, web beacons. Łącznie te technologie będziemy dalej zbiorczo określać jako „<b>pliki cookies</b>”. <br><br>Z wykorzystaniem plików cookies możemy pozyskiwać i przetwarzać m.in. informacje dot. wykorzystywanej przez Ciebie przeglądarki i jej wersji, systemu operacyjnego, URL poprzednio odwiedzanej strony, adresu IP, czasu żądania serwera, ID użytkownika, języka, wyszukiwania w serwisie, produktów dodanych do koszyka, danych dot. uwierzytelniania, danych dot. odtwarzanych treści i innych aktywności w serwisie lub aplikacji. Identyfikator użytkownika łączymy z innymi danymi pochodzącymi od Ciebie (np. adres email, numer telefonu)."
          },
          {
            "heading": "Z jakich plików cookies korzystamy?",
            "link": "type-of-cookie",
            "content": "<p> Listę plików cookies stosowanych w naszych serwisach i aplikacjach, wraz z informacjami o ich pochodzeniu, celu stosowania, okresie przechowywania oraz dostawcy, a naszym partnerze (dalej: „Partner”) znajdziesz poniżej. Poniżej dostępne są także dodatkowe istotne informacje.  </p>"
          },
          {
            "heading": "W jakim celu wykorzystujemy pliki cookies?",
            "link": "why-cookies",
            "content": "<p>Pliki cookies dzielimy i wykorzystujemy w sposób opisany poniżej: </p><ol><li> <p><b>Pliki cookies „niezbędne”</b> – te pliki cookies są niezbędne do funkcjonowania serwisów i aplikacji. Dzięki nadanym ID oraz zebranym danym pozwalają na korzystanie z ich zasobów i funkcjonalności (np. zapamiętują Cię jako zalogowanego użytkownika, zapewniają prawidłowe odtwarzanie treści na stronie), a także zwiększają wydajność, pozwalają na szybsze odnalezienie potrzebnych informacji, służą zapamiętaniu Twoich ustawień dot. plików cookies oraz wspierają bezpieczeństwo serwisów, aplikacji i świadczonych usług. Bez tych plików cookies korzystanie ze stron internetowych Benefit Systems nie będzie możliwe.</p> </li></ol>"
          },
          {
            "onlySlot": true,
            "heading": "",
            "link": "",
            "content": ""
          },
          {
            "heading": "",
            "link": "",
            "content": "<p>Pliki cookies poza tymi niezbędnymi do funkcjonowania naszych serwisów i aplikacji są instalowane w przypadku wyrażenia zgody. Brak zgody na pliki cookies inne niż niezbędne nie uniemożliwi korzystania z naszych stron internetowych, ale może wpłynąć negatywnie na doznania użytkownika (np. reklamy nie będą dostosowane zgodnie z zainteresowaniami użytkownika). <br><br>Wśród plików cookies innych niż niezbędne wyróżniamy: <ol start=\"2\"><li class=\"analitic-list-element-1\"><p><b>Pliki cookies marketingowe</b> – te pliki cookies gromadzą informacje o aktywności użytkowników w naszych serwisach lub aplikacjach. Informacje te są wykorzystywane do profilowania na potrzeby marketingu, przedstawiania spersonalizowanych treści i ofert dostosowanych do Twoich potencjalnych zainteresowań lub profilu, prowadzenia kampanii reklamowanych, w tym retargetowania. Z wykorzystaniem tych plików zbierane są informacje np. o tym że odwiedziłeś nasze serwisy i jakie aktywności wykonałeś w naszych serwisach. Pozwalają one nam oraz Partnerom docierać z naszym komunikatem marketingowym do określonych grup użytkowników, którzy wcześniej odwiedzili nasze serwisy lub aplikacje oraz monitorować realizację kampanii reklamowych. Ich stosowanie wymaga Twojej zgody.</p></li></ol>"
          },
          {
            "onlySlot": true,
            "heading": "",
            "link": "",
            "content": ""
          },
          {
            "heading": "",
            "link": "",
            "content": "<ol><li class=\"analitic-list-element-2\"><p><b>Pliki cookies analityczne</b> – te pliki cookies służą do zbierania informacji analitycznych i statystycznych, np. liczenia wizyt w serwisach lub aplikacjach, badania czasu trwania wizyt, źródeł ruchu oraz do określenia, jakie funkcjonalności lub części serwisów lub aplikacji są najczęściej wykorzystywane lub odwiedzane. Dzięki tym informacjom dowiadujemy się jakie serwisy lub funkcjonalności cieszą się popularnością, jaka jest wydajność serwisów i aplikacji oraz co wymaga usprawnień. Te informacje pozwalają nam planować rozwój serwisów i aplikacji. Ich stosowanie wymaga Twojej zgody.</p></li></ol>"
          },
          {
            "onlySlot": true,
            "heading": "",
            "link": "",
            "content": ""
          },
          {
            "heading": "",
            "link": "",
            "content": "<p>Ponadto, pliki cookies dzielimy na:</p><ol><li><p><b>Sesyjne pliki cookies</b> –pliki, które są przechowywane krótkookresowo (np. do momentu zamknięcia przeglądarki internetowej). Sesyjne pliki cookies są niezbędne do tego, by strona internetowa funkcjonowała prawidłowo.</p></li><li><p><b>Stałe pliki cookies</b> – pliki, które odpowiadają za zachowywanie ustawień strony internetowej oraz poprawiają doświadczenie użytkownika (np. zapamiętywanie treści wprowadzonych do formularzy, lokalizacji użytkownika, informacji o rozdzielczości oraz o rozmiarze i kroju czcionki).</p></li></ol>"
          },
          {
            "heading": "Czy wykorzystujemy pliki cookies podmiotów zewnętrznych?",
            "link": "other-cookies",
            "content": "<p>Tak, gdy korzystasz z naszych serwisów lub aplikacji możesz otrzymywać pliki cookies pochodzące od zewnętrznych podmiotów, z którymi współpracujemy, czyli naszych Partnerów. Z tych plików cookies korzystamy głównie w celach analitycznych i marketingowych. </p><p>Używamy następujących narzędzi dostarczanych przez Partnerów, związanych z wykorzystaniem plików cookies i identyfikatorów:</p><ol><li> <p><b>Google Tag Manager</b>  – narzędzie, które umożliwia zarządzanie tagami umieszczanymi w serwisach. Samo narzędzie nie wykorzystuje plików cookies, a służy do zarządzania tagami, które mogą prowadzić do zapisywania plików cookies.</p></li></ol><p><b>Narzędzia analityczne</b></p><ol><li><p><b>Google Analytics</b> – narzędzie, które służy do zbierania danych analitycznych tj. zliczania wizyt w serwisach lub aplikacjach, badania czasu trwania wizyt oraz określenia, jakie funkcjonalności lub części serwisów lub aplikacji są najczęściej wykorzystywane lub odwiedzane. Google Analytics wykorzystuje pliki cookies i tworzy spseudonimizowane profile użytkowników. Adresy IP pozyskane przez narzędzie są anonimizowane tak, aby nie było możliwe ich przyporządkowanie do konkretnego użytkownika. </p><p>Możesz zablokować zbieranie informacji o Twojej aktywności przez Google Analytics korzystając ze strony: <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://tools.google.com/dlpage/gaoptout\">tools.google.com/dlpage/gaoptout</a>  </p></li><li><p><b>Hotjar</b> – narzędzie, które służy do zbierana danych analitycznych o zachowaniu i preferencjach użytkowników w naszych serwisach np. czas spędzany na konkretnych stronach, najczęściej klikane elementy. Hotjar przechowuje wyżej wymienione informacje w pseudonimizowanym profilu użytkownika. Ani Hotjar, ani my nie użyjemy tych informacji do ustalenia tożsamości poszczególnych użytkowników lub do dopasowania ich do dalszych danych danego użytkownika. </p><p>Możesz zablokować zbieranie informacji o Twojej aktywności przez HotJar korzystając z informacji na stronie: <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://help.hotjar.com/hc/en-us/articles/360002735873-How-to-Stop-Hotjar-From-Collecting-your-Data\">help.hotjar.com/hc/en-us/articles/360002735873-How-to-Stop-Hotjar-From-Collecting-your-Data</a> </p></li></ol><p><b>Narzędzia marketingowe</b></p><ol><li><p><b>Synerise, SALESmanago </b>– narzędzia wspomagające automatyzację procesów marketingowych oraz sprzedażowych, w tym przetwarzanie danych marketingowych i sprzedażowych oraz ich złożoną analitykę w tzw. modelu wielokanałowym, czyli w modelu pozwalającym dotrzeć do użytkownika poprzez różne kanały (np. strony internetowe, powiadomienia push, SMS, MMS, e-mail, czat, telefon itd.) i różne urządzenia (np. komputer, smartfon, tablet, telefon). </p></li><li><p><b>Google Ads</b> – system reklamowy firmy Google, umożliwiający emisję reklam tekstowych, graficznych, video oraz wyświetlanie linków sponsorowanych w wynikach wyszukiwania wyszukiwarki Google i na stronach współpracujących w ramach programu Google AdSense.</p></li><li><p><b>Google Marketing Platform</b> – platforma, dzięki której możemy korzystać z wielu narzędzi marketingowych Google po to, aby dostarczać użytkownikom dopasowane reklamy, unikać wyświetlania ponownie reklam, które użytkownik już widział, optymalizować kampanie oraz monitorować poziom ich realizacji. </p><p>Możesz zablokować działanie narzędzi reklamowych Google korzystając z informacji na stronie: <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://www.google.com/settings/ads/plugin\">www.google.com/settings/ads/plugin</a></p><li><p><b>Facebook (Meta) Ads Manager</b> – system reklamowy Facebooka, umożliwiający tworzenie, wykupienie i zarządzanie reklamami w ramach sieci społecznościowej Facebook, Instagram, Messenger i Audience Network Facebooka. W naszych serwisach używamy Piksel Facebooka. Pozwala nam śledzić działania na naszej stronie internetowej i na tej podstawie wyświetlać Tobie reklamy dopasowane do Twoich potrzeb lub wyświetlać reklamy innym użytkownikom Facebook o profilu podobnym do Ciebie. </p><p>Użytkownicy Facebook mogą zarządzać preferencjami dot. reklam na stronie: <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://www.facebook.com/ads/preferences\">www.facebook.com/ads/preferences</a> (dodatkowo na tej stronie w sekcji <i>Ustawienia reklam</i>, możesz także wyłączyć możliwość personalizacji reklam dostarczanych przez Facebook z wykorzystaniem danych pochodzących od nas). </p><p>Pozostałe osoby mogą zarządzać tymi preferencjami na stronie: <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://www.facebook.com/settings/ads/\">www.facebook.com/settings/ads/</a> lub za pomocą strony: <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://www.youronlinechoices.com/pl/twojewybory\">www.youronlinechoices.com/pl/twojewybory</a>.</p></li></ol><p>Dodatkowo, poza wskazanymi wyżej narzędziami, w naszych serwisach i aplikacjach stosowane są pliki cookies innych zewnętrznych Partnerów. Pełną listę Partnerów znajdziesz w sekcji <i><b>Z jakich plików cookies korzystamy?</b></i>.</p><p>Możesz zablokować dopasowane reklamy od Partnerów należących do programu „About Ads” za pomocą strony <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://www.aboutads.info/choices\">www.aboutads.info/choices</a> lub „European Interactive Digital Advertising Alliance” za pomocą strony <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://www.youronlinechoices.com/pl/twojewybory\">www.youronlinechoices.com/pl/twojewybory</a>. Blokadę należy ustawić dla każdej z przeglądarek. Będzie ona działała do momentu usunięcia plików cookies z przeglądarki.</p>"
          },
          {
            "heading": "Jak zarządzać plikami cookies?",
            "link": "menage-cookies",
            "content": "<p>Pliki cookies, poza plikami niezbędnymi do funkcjonowania strony, są wykorzystywane przez nas wyłącznie za zgodą użytkownika. Gdy wejdziesz na naszą stronę, poprosimy Cię o dokonanie wyborów dotyczących tych plików.&nbsp;</p><p>Swoimi wyborami możesz zarządzać z perspektywy rodzaju plików <i>cookies,</i> ale także Partnera, od którego pochodzą.&nbsp;</p><p>W każdym momencie możesz zmienić swoje wybory klikając w opcję <b>Ustawienia </b><i><b>cookies</b></i><b>,</b> znajdującą się w stopce strony.&nbsp;</p><p>Ponadto, co powyżej, w każdym momencie możesz także wyłączyć, usunąć już zapisane pliki cookies lub zmodyfikować możliwość ich zapisywania na swoim urządzeniu poprzez zmianę ustawień przeglądarki. Pamiętaj, że zmiana ustawień przeglądarki polegająca na wyłączeniu lub ograniczeniu możliwości zapisywania plików cookies może spowodować ograniczenie funkcjonalności serwisów lub aplikacji.&nbsp;</p><p>W pasku menu każdej przeglądarki internetowej w sekcji „Pomoc” znajdziesz informacje o tym jak zarządzać ustawieniami plików cookies. Poniżej znajdziesz szczegółowe informacje o zarządzaniu ustawieniami plików cookies w najpopularniejszych przeglądarkach:</p><ol><li><a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.microsoft.com/en-us/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09\">Edge</a></li><li><a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.google.com/chrome/answer/95647?hl=pl\">Chrome</a></li><li><a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.apple.com/pl-pl/guide/safari/sfri11471/mac\">Safari</a></li><li><a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.mozilla.org/en-US/kb/enhanced-tracking-protection-firefox-desktop?redirectlocale=en-US&amp;redirectslug=enable-and-disable-cookies-website-preferences\">Firefox</a></li></ol>"
          },
          {
            "heading": "Dodatkowe istotne informacje dotyczące sposobu działania Serwisów:",
            "link": "storage",
            "content": "<p><b>Local Storage</b></p><p>Nasze serwisy korzystają także z technologii zwanej Local Storage. Local Storage to miejsce przechowywania informacji udostępnianych przez Twoją przeglądarkę. W odróżnieniu od plików <i>cookies,</i> dane zapisane w Local Storage nie są przesyłane przez przeglądarkę przy każdych odwiedzinach witryny. Zapiszemy tu np. Twoje wyszukania, tak, aby po ponownym ich wpisaniu wyświetliły się w podpowiedzi i tym samym, aby Twoje wyszukanie było szybsze.</p><p><b> →  Jak usunąć dane z Local Storage?</b></p><p>Local Storage przechowuje dane długotrwale, do momentu przywrócenia przez Ciebie ustawień domyślnych lub ręcznego usunięcia danych z pamięci podręcznej przeglądarki. Instrukcję jak to zrobić znajdziesz powyżej lub w pasku menu każdej przeglądarki internetowej w sekcji „Pomoc”.</p><p><b>Powiadomienia push</b></p><p>Powiadomienia push to krótkie komunikaty, które wyświetlają się na ekranie Twojego urządzenia.</p><p>Dla nas jest to jedno z narzędzi wspierających komunikację z Tobą. Dla Ciebie jest to źródło wiedzy o naszych usługach, w tym o nowościach, obiektach i aktywnościach sezonowych, akcjach, konkursach lub wydarzeniach.</p><p>Otrzymywanie komunikatów push wymaga Twojej zgody. Po wejściu do serwisu lub aplikacji zapytamy Cię o to, czy chcesz otrzymywać od nas powiadomienia. Jeżeli wyrazisz zgodę, będziemy mogli przesyłać interesujące Cię treści nawet wtedy, kiedy opuścisz nasz serwis lub aplikację.</p><p><b> →  Jak wyłączyć powiadomienia push?</b></p><p>Możesz zrezygnować z otrzymywania powiadomień w dowolnym momencie, zmieniając ustawienia przeglądarki lub aplikacji. Poniżej znajdziesz szczegółowe informacje jak je wyłączyć w najpopularniejszych przeglądarkach:</p><ol><li><a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.microsoft.com/pl-pl/microsoft-edge/blokowanie-wyskakuj%C4%85cych-okienek-w-przegl%C4%85darce-microsoft-edge-1d8ba4f8-f385-9a0b-e944-aa47339b6bb5\">Edge</a></li><li><a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.google.com/chrome/answer/3220216?hl=pl&amp;co=GENIE.Platform%3DDesktop\">Chrome</a> </li><li><a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.apple.com/pl-pl/guide/safari/sfri40734/mac\">Safari</a></li><li><a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.mozilla.org/pl/kb/powiadomienia-web-push-firefox\">Firefox</a></li></ol><p><b>Lokalizacja</b></p><p>W przeglądarce, aplikacji lub w ustawienia swojego urządzenia możesz wyrazić zgodę na wykorzystanie danych dot. lokalizacji. Używamy tej funkcji, aby dostarczyć Ci informacji np. lokalizację najbliższego klubu fitness lub reklamy i oferty dopasowane do Twojego miejsca pobytu.</p><p><b> →  Jak wyłączyć udostępnianie lokalizacji?</b></p><p>Udostępnianie lokalizacji możesz wyłączyć korzystając z ustawień aplikacji, urządzenia lub Twojej przeglądarki:</p><ol><li><a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.microsoft.com/pl-pl/microsoft-edge/lokalizacja-i-prywatno%C5%9B%C4%87-w-przegl%C4%85darce-microsoft-edge-31b5d154-0b1b-90ef-e389-7c7d4ffe7b04\">Edge</a></li><li><a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.google.com/accounts/answer/3467281?hl=pl#location_accuracy\">Chrome</a></li><li><a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.apple.com/pl-pl/HT5403\">Safari</a></li><li><a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.mozilla.org/pl/kb/czy-firefox-udostepnia-moje-polozenie-stronom?redirectlocale=en-US&amp;redirectslug=does-firefox-share-my-location-web-sites\">Firefox</a></li></ol><p></p><p>W przypadku pytań dotyczących plików cookies wykorzystywanych w naszych serwisach i aplikacjach, bądź w razie chęci skorzystania ze swoich praw z zakresu ochrony danych osobowych, prosimy o kontakt w sposób określony tu: <a href=\"http://benefitsystems.pl/polityka-prywatnosci/\" target=\"_blank\">http://benefitsystems.pl/polityka-prywatnosci.</a></p>"
          }
        ]
      }
      },
      "cookiesProvidersNecessery" : [
        {
          "name": "Benefit Systems S.A.",
          "cookies": [
            {
              "name": "ddc_ad_personalization",
              "expired": "THIRTY_DAYS",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "ddc_ad_storage",
              "expired": "THIRTY_DAYS",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "ddc_ad_user_data",
              "expired": "THIRTY_DAYS",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "ddc_analytics_storage",
              "expired": "THIRTY_DAYS",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "ddc_functionality_storage",
              "expired": "THIRTY_DAYS",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "ddc_personalization_storage",
              "expired": "THIRTY_DAYS",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "ddc_security_storage",
              "expired": "THIRTY_DAYS",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "SULUSESSID",
              "expired": "END_OF_SESSION",
              "means": "Utrzymanie sesji",
              "type": "NECESSARY"
            },
            {
              "name": "form_phone",
              "expired": "THIRTY_DAYS",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "cookies",
              "expired": "ONE_YEAR",
              "means": "Zbiera informacje o zgodzie na cookies",
              "type": "NECESSARY"
            },
            {
              "name": "kctd_SMS",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "kctd_EMAIL",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "kctd_AUTHENTICATOR",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "cookie_consent",
              "expired": "ONE_YEAR",
              "means": "Zbiera informacje o zgodzie na cookies, po kliknięciu w przycisk ‘zaakceptuj’ na pasku informującym o cookie",
              "type": "NECESSARY"
            },
            {
              "name": "fe_typo_user",
              "expired": "END_OF_SESSION",
              "means": "Identyfikacja ID sesji, gdy użytkownik jest zalogowany",
              "type": "NECESSARY"
            },
            {
              "name": "storedId",
              "expired": "END_OF_SESSION",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "relayState",
              "expired": "END_OF_SESSION",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "isCookiesAccepted",
              "expired": "ONE_YEAR",
              "means": "Informacja o świadomym zamknięciu okna z informacją polityki prywatności przez użytkownika",
              "type": "NECESSARY"
            },
            {
              "name": "APPID",
              "expired": "END_OF_SESSION",
              "means": "ID aplikacji przechowywane na potrzeby działania procesów w kafeterii",
              "type": "NECESSARY"
            },
            {
              "name": "XSRF-TOKEN",
              "expired": "END_OF_SESSION",
              "means": "Zapewnienie bezpieczeństwa",
              "type": "NECESSARY"
            },
            {
              "name": "BENEFIT_SESSIONID",
              "expired": "END_OF_SESSION",
              "means": "Identyfikator sesji",
              "type": "NECESSARY"
            },
            {
              "name": "lang",
              "expired": "END_OF_SESSION",
              "means": "Zapamiętanie preferencji języka przez użytkownika",
              "type": "NECESSARY"
            },
            {
              "name": "AUTH_SESSION_ID",
              "expired": "END_OF_SESSION",
              "means": "Identyfikator bieżącej sesji uwierzytelniania",
              "type": "NECESSARY"
            },
            {
              "name": "AUTH_SESSION_ID_LEGACY",
              "expired": "END_OF_SESSION",
              "means": "Używany do procesu uwierzytelniania",
              "type": "NECESSARY"
            },
            {
              "name": "KC_RESTART",
              "expired": "END_OF_SESSION",
              "means": "Używany do procesu uwierzytelniania",
              "type": "NECESSARY"
            },
            {
              "name": "KEYCLOAK_LOCALE",
              "expired": "END_OF_SESSION",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "rc::a",
              "expired": "END_OF_SESSION",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "ASP.NET_SessionId",
              "expired": "END_OF_SESSION",
              "means": "Rejestrowanie obecnej sesji użytkownika",
              "type": "NECESSARY"
            },
            {
              "name": "cookiepolicyinfo",
              "expired": "END_OF_SESSION",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "MT_PHPSESSID",
              "expired": "END_OF_SESSION",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "cookie",
              "expired": "END_OF_SESSION",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "PHPSESSID",
              "expired": "END_OF_SESSION",
              "means": "Utrzymanie sesji i identyfikowanie sesji klienta",
              "type": "NECESSARY"
            }
          ]
        },
        {
          "name": "Creative CDN",
          "cookies": [
            {
              "name": "receive-cookie-deprecation",
              "expired": "SEVEN_MONTHS",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "receive-cookie-deprecation",
              "expired": "SIX_MONTHS",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "receive-cookie-deprecation",
              "expired": "EIGHT_MONTHS",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "receive-cookie-deprecation",
              "expired": "SIX_MONTHS",
              "means": "",
              "type": "NECESSARY"
            }
          ]
        },
        {
          "name": "Didomi",
          "cookies": [
            {
              "name": "didomi_token",
              "expired": "THIRTY_DAYS",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "euconsent-v2",
              "expired": "THIRTY_DAYS",
              "means": "",
              "type": "NECESSARY"
            }
          ]
        },
        {
          "name": "Freshdesk",
          "cookies": [
            {
              "name": "_x_w",
              "expired": "END_OF_SESSION",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "eachSlice",
              "expired": "END_OF_SESSION",
              "means": "",
              "type": "NECESSARY"
            }
          ]
        },
        {
          "name": "Google Ireland Ltd                                   ",
          "cookies": [
            {
              "name": "rc::c",
              "expired": "END_OF_SESSION",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "__Secure-1PAPISID",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "__Secure-1PSID",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "__Secure-1PSIDCC",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "__Secure-1PSIDTS",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "__Secure-3PAPISID",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "__Secure-3PSID",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "__Secure-3PSIDCC",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "__Secure-3PSIDTS",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "__Secure-ENID",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "AEC",
              "expired": "FIVE_MONTHS",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "HSID",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "SAPISID",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "SAPISID",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "SAPISID",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "SEARCH_SAMESITE",
              "expired": "FIVE_MONTHS",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "SID",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "SIDCC",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "SOCS",
              "expired": "FIVE_MONTHS",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "SSID",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "SAPISID",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "NECESSARY"
            }
          ]
        },
        {
          "name": "Inteliwise S.A.",
          "cookies": [
            {
              "name": "focus-id-",
              "expired": "END_OF_SESSION",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "iw-ichr-cokie-Inteliwise-SaasModule_",
              "expired": "END_OF_SESSION",
              "means": "",
              "type": "NECESSARY"
            }
          ]
        },
        {
          "name": "Intercom, Inc.",
          "cookies": [
            {
              "name": "intercom-id-[app_id]",
              "expired": "NINE_MONTHS",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "intercom-session-[app_id]",
              "expired": "SEVEN_DAYS",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "intercom-device-id-[app_id]",
              "expired": "NINE_MONTHS",
              "means": "",
              "type": "NECESSARY"
            }
          ]
        },
        {
          "name": "Keycloak",
          "cookies": [
            {
              "name": "KEYCLOAK_3P_COOKIE_SAMESITE",
              "expired": "ONE_MINUTE",
              "means": "",
              "type": "NECESSARY"
            }
          ]
        },
        {
          "name": "Meta Platforms Ireland Limited",
          "cookies": [
            {
              "name": "datr",
              "expired": "TEN_MONTHS",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "presence",
              "expired": "THIRTY_DAYS",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "sb",
              "expired": "ELEVEN_MONTHS",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "usida",
              "expired": "END_OF_SESSION",
              "means": "",
              "type": "NECESSARY"
            },
            {
              "name": "xs",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "NECESSARY"
            }
          ]
        },
        {
          "name": "PerfectGym",
          "cookies": [
            {
              "name": "ClientPortal.Embed",
              "expired": "END_OF_SESSION",
              "means": "",
              "type": "NECESSARY"
            }
          ]
        },
        {
          "name": "Prowly Journal",
          "cookies": [
            {
              "name": "prowly-journal-session",
              "expired": "END_OF_SESSION",
              "means": "",
              "type": "NECESSARY"
            }
          ]
        },
        {
          "name": "Vimeo.com, Inc.",
          "cookies": [
            {
              "name": "vuid",
              "expired": "THIRTEEN_MONTHS",
              "means": "",
              "type": "NECESSARY"
            }
          ]
        },
        {
          "name": ".vimeo.com",
          "cookies": [
            {
              "name": "__cf_bm",
              "expired": "THIRTY_MINUTES",
              "means": "",
              "type": "NECESSARY"
            }
          ]
        }
      ],
      "cookiesProvidersMarketing" : [
        {
          "name": "Benhauer sp. z o.o. ",
          "cookies": [
            {
              "name": "smvr",
              "expired": "THREE_YEARS",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "smuuid",
              "expired": "THREE_YEARS",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "smcfds",
              "expired": "END_OF_SESSION",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "smclient",
              "expired": "THREE_YEARS",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "smwp",
              "expired": "THREE_YEARS",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "smuuid",
              "expired": "TEN_YEARS",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "_smvs",
              "expired": "ONE_DAY",
              "means": "",
              "type": "MARKETING"
            }
          ]
        },
        {
          "name": "Creative CDN ",
          "cookies": [
            {
              "name": "g",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "MARKETING"
            }
          ]
        },
        {
          "name": "Criteo S.A.",
          "cookies": [
            {
              "name": "cto_bundle",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "MARKETING"
            }
          ]
        },
        {
          "name": ".ctnsnet.com",
          "cookies": [
            {
              "name": "cid_*",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "MARKETING"
            }
          ]
        },
        {
          "name": ".doubleclick.net",
          "cookies": [
            {
              "name": "test_cookie",
              "expired": "FIFTEEN_MINUTES",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "IDE",
              "expired": "ONE_YEAR_24_DAYS",
              "means": "",
              "type": "MARKETING"
            }
          ]
        },
        {
          "name": "Floodlight",
          "cookies": [
            {
              "name": "HSID",
              "expired": "TWO_YEARS",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "DSID",
              "expired": "TWO_YEARS",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "SIDCC",
              "expired": "TWO_YEARS",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "SAPISID",
              "expired": "TWO_YEARS",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "ANID",
              "expired": "TWO_YEARS",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "1P_JAR",
              "expired": "TWO_YEARS",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "SSID",
              "expired": "TWO_YEARS",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "NID",
              "expired": "TWO_YEARS",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "SID",
              "expired": "TWO_YEARS",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "APISID",
              "expired": "TWO_YEARS",
              "means": "",
              "type": "MARKETING"
            }
          ]
        },
        {
          "name": "Google Ireland Ltd",
          "cookies": [
            {
              "name": "_gcl_au",
              "expired": "THREE_MONTHS",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "APISID",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "CONSENT",
              "expired": "FIVE_MONTHS",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "IDE",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "NID",
              "expired": "FIVE_MONTHS",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "NID",
              "expired": "SIX_MONTHS",
              "means": "",
              "type": "MARKETING"
            }
          ]
        },
        {
          "name": "Hot Jar Ltd.",
          "cookies": [
            {
              "name": "_hjAbsoluteSessionInProgress",
              "expired": "THIRTY_MINUTES",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "_hjFirstSeen",
              "expired": "THIRTY_MINUTES",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "_hjSessionUser_*",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "_hjSession_*",
              "expired": "THIRTY_MINUTES",
              "means": "",
              "type": "MARKETING"
            }
          ]
        },
        {
          "name": "LinkedIn Ireland",
          "cookies": [
            {
              "name": "UserMatchHistory",
              "expired": "ONE_MONTH",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "lang",
              "expired": "END_OF_SESSION",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "lidc",
              "expired": "ONE_DAY",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "AnalyticsSyncHistory",
              "expired": "ONE_MONTH",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "li_gc",
              "expired": "TWO_YEARS",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "bcookie",
              "expired": "TWO_YEARS",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "bscookie",
              "expired": "TWO_YEARS",
              "means": "",
              "type": "MARKETING"
            }
          ]
        },
        {
          "name": "Meta Platforms Ireland Limited",
          "cookies": [
            {
              "name": "_fbp",
              "expired": "NINETY_DAYS",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "c_user",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "dpr",
              "expired": "SEVEN_DAYS",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "fr",
              "expired": "SIXTY_DAYS",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "oo",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "fr",
              "expired": "NINETY_DAYS",
              "means": "",
              "type": "MARKETING"
            }
          ]
        },
        {
          "name": "Microsoft",
          "cookies": [
            {
              "name": "_uetsid",
              "expired": "ONE_DAY",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "_uetvid",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "MARKETING"
            }
          ]
        },
        {
          "name": ".revhunter.tech",
          "cookies": [
            {
              "name": "adf",
              "expired": "ONE_MONTH",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "history",
              "expired": "ONE_MONTH",
              "means": "",
              "type": "MARKETING"
            }
          ]
        },
        {
          "name": "RTB House",
          "cookies": [
            {
              "name": "__rtbh.uid",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "MARKETING"
            }
          ]
        },
        {
          "name": "Synerise S.A. ",
          "cookies": [
            {
              "name": "_snrs_sb",
              "expired": "THIRTY_MINUTES",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "_snrs_sa",
              "expired": "THIRTY_MINUTES",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "_snrs_*",
              "expired": "TWO_YEARS",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "_snrs_uuid",
              "expired": "FOUR_HUNDRED_DAYS",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "_snrs_puuid",
              "expired": "FOUR_HUNDRED_DAYS",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "_snrs_p",
              "expired": "FOUR_HUNDRED_DAYS",
              "means": "",
              "type": "MARKETING"
            }
          ]
        },
        {
          "name": "TikTok",
          "cookies": [
            {
              "name": "_tt_enable_cookie",
              "expired": "THIRTEEN_MONTHS",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "_ttp",
              "expired": "THIRTEEN_MONTHS",
              "means": "",
              "type": "MARKETING"
            }
          ]
        },
        {
          "name": "Youtube ",
          "cookies": [
            {
              "name": "YSC",
              "expired": "END_OF_SESSION",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "VISITOR_INFO1_LIVE",
              "expired": "FIVE_MONTHS_27_DAYS",
              "means": "",
              "type": "MARKETING"
            },
            {
              "name": "CONSENT",
              "expired": "TWO_YEARS",
              "means": "",
              "type": "MARKETING"
            }
          ]
        }
      ],
      "cookiesProvidersAnalytics" : [
        {
          "name": "Benefit Systems S.A. ",
          "cookies": [
            {
              "name": "catAccCookies",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "MyBenefitCookies",
              "expired": "END_OF_SESSION",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "_hjFirstSeen",
              "expired": "END_OF_SESSION",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "_hjSession_",
              "expired": "END_OF_SESSION",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "_hjSessionUser_",
              "expired": "END_OF_SESSION",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "_ga",
              "expired": "TWO_YEARS",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "_gid",
              "expired": "TWENTY_FOUR_HOURS",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "PastVisitor",
              "expired": "END_OF_SESSION",
              "means": "",
              "type": "ANALYTICS"
            }
          ]
        },
        {
          "name": "Didomi",
          "cookies": [
            {
              "name": "didomi_token",
              "expired": "ONE_MONTH",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "euconsent-v2",
              "expired": "ONE_MONTH",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "__utmt",
              "expired": "TEN_MINUTES",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "__utmz",
              "expired": "SIX_MONTHS",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "__utma",
              "expired": "TWO_YEARS",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "__utmc",
              "expired": "END_OF_SESSION",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "__utmb",
              "expired": "THIRTY_MINUTES",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "ahoy_visitor",
              "expired": "TWO_YEARS",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "ahoy_visit",
              "expired": "THIRTY_MINUTES",
              "means": "",
              "type": "ANALYTICS"
            }
          ]
        },
        {
          "name": "Google Ireland Ltd",
          "cookies": [
            {
              "name": "_dc_gtm_UA-*",
              "expired": "ONE_MINUTE",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "_gat",
              "expired": "ONE_MINUTE",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "_gid",
              "expired": "TWENTY_FOUR_HOURS",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "_ga_*",
              "expired": "TWO_YEARS",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "_gat_UA-*",
              "expired": "ONE_MINUTE",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "_ga_",
              "expired": "TWO_YEARS",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "gat_",
              "expired": "ONE_MINUTE",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "__utmz",
              "expired": "SIX_MONTHS",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "__utmc",
              "expired": "END_OF_SESSION",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "__utma",
              "expired": "TWO_YEARS",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "__utmb",
              "expired": "THIRTY_MINUTES",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "__utmt",
              "expired": "TEN_MINUTES",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "_gat_gtag_UA_151102250_1",
              "expired": "ONE_MINUTE",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "_gat_UA*",
              "expired": "ONE_MINUTE",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "ar_debug",
              "expired": "THIRTY_DAYS",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "hjIncludedInPageviewSample",
              "expired": "END_OF_SESSION",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "_BEAMER_FIRST_VISIT_*",
              "expired": "NINETY_DAYS",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "_BEAMER_LAST_UPDATE_*",
              "expired": "NINETY_DAYS",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "_BEAMER_USER_ID_*",
              "expired": "NINETY_DAYS",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "_hp2_id.*",
              "expired": "NINE_MONTHS",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "userty.core.p.*",
              "expired": "NINE_MONTHS",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "_hjSessionUser_*",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "_hjAbsoluteSessionInProgress",
              "expired": "THIRTY_MINUTES",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "_hjClosedSurveyInvites",
              "expired": "YEAR_ON_DAYS",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "_hjDonePolls",
              "expired": "YEAR_ON_DAYS",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "_hjMinimizedPolls",
              "expired": "YEAR_ON_DAYS",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "_hjShownFeedbackMessage",
              "expired": "YEAR_ON_DAYS",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "_hjSessionTooLarge",
              "expired": "END_OF_SESSION",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "_hjIncludedInSessionSample",
              "expired": "THIRTY_MINUTES",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "_hjSessionRejected",
              "expired": "END_OF_SESSION",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "_hjid",
              "expired": "YEAR_ON_DAYS",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "_hjRecordingLastActivity",
              "expired": "END_OF_SESSION",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "_hjTLDTest",
              "expired": "END_OF_SESSION",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "_hjUserAttributesHash",
              "expired": "END_OF_SESSION",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "_hjCachedUserAttributes",
              "expired": "END_OF_SESSION",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "_hjLocalStorageTest",
              "expired": "ONE_HUNDRED_MS",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "_hjIncludedInPageviewSample",
              "expired": "THIRTY_MINUTES",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "_hjViewportId",
              "expired": "END_OF_SESSION",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "_hjRecordingEnabled",
              "expired": "END_OF_SESSION",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "_hjFirstSeen",
              "expired": "THIRTY_MINUTES",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "_hjSession_*",
              "expired": "THIRTY_MINUTES",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "hjSession",
              "expired": "THIRTY_MINUTES",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "hjSessionUser",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "wd",
              "expired": "SEVEN_DAYS",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "_clck",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "_clsk",
              "expired": "ONE_DAY",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "CLID",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "ANONCHK",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "MR",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "MUID",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "SM",
              "expired": "ONE_YEAR",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "ts",
              "expired": "SIXTY_DAYS",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "u",
              "expired": "FIVE_MONTHS",
              "means": "",
              "type": "ANALYTICS"
            },
            {
              "name": "uid",
              "expired": "ELEVEN_MONTHS",
              "means": "",
              "type": "ANALYTICS"
            }
          ]
        },
        {
          "name": ".adform.net",
          "cookies": [
            {
              "name": "uid",
              "expired": "TWO_MONTHS",
              "means": "",
              "type": "ANALYTICS"
            }
          ]
        },
        {
          "name": ".ctnsnet.com",
          "cookies": [
            {
              "name": "cid",
              "expired": "ONE_MONTH",
              "means": "",
              "type": "ANALYTICS"
            }
          ]
        }
      ]
    },
    "privacy": {
      "header": "Spis treści",
      "subheader": "Jeżeli chcesz przejść do wybranej sekcji, kliknij w link poniżej:",
      "list": [
        {
          "heading": "Informacja ogólna",
          "link": "about",
          "content": "Ochronę danych osobowych traktujemy w Benefit Systems S.A. (dalej: <b>„Benefit Systems”, „my”</b>) bardzo poważnie. \n Dokładamy należytej staranności, żeby Twoje dane osobowe były przetwarzane zgodnie z obowiązującymi przepisami prawa polskiego i \n Unii Europejskiej, w tym z rozporządzeniem Parlamentu Europejskiego i Rady (UE) z dnia 27 kwietnia 2016 r. w sprawie ochrony osób \n fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE \n (dalej: <b>„RODO”</b>).\n <br><br>\n Poniżej znajdziesz informacje o tym w jaki sposób przetwarzamy Twoje dane, w szczególności podstawy prawne przetwarzania, \n sposoby zbierania i wykorzystywania Twoich danych osobowych oraz prawa przysługujące Ci w związku z przetwarzaniem przez nas \n Twoich danych osobowych."
        },
        {
          "heading": "Kto jest administratorem Twoich danych osobowych i co to oznacza",
          "link": "admin",
          "content": "Administratorem Twoich danych osobowych jest Benefit Systems (Benefit Systems S.A. z siedzibą w Warszawie, Pl. Europejski 2, 00-844 Warszawa).\n <br><br>\n Oznacza to, że Benefit Systems decyduje o celach i sposobach przetwarzania Twoich danych osobowych, czyli o tym, po co i w jaki sposób \n będą one wykorzystywane."
        },
        {
          "heading": "Jak się z nami skontaktować",
          "link": "contact",
          "content": "<b>Możesz się z nami skontaktować w następujący sposób:</b>\n <br>\n <ol>\n <li><span>Przez <a href=\"https://www.benefitsystems.pl/pomoc-i-obsluga/rodo/\">formularz kontaktowy</a></span></li>\n <li><span>Przez adres email: <a href=\"mailto:daneosobowe&#64;benefitsystems.pl\">daneosobowe&#64;benefitsystems.pl</a></span></li>\n <li><span>Przez adres email dedykowany dla klientów naszych klubów fitness: <a href=\"mailto:daneosobowe&#64;fitness.benefitsystems.pl\">\n daneosobowe&#64;fitness.benefitsystems.pl</a></span></li>\n <li><span>Listownie na adres: Benefit Systems S.A., Pl. Europejski 2, 00-844 Warszawa, z dopiskiem „Dane osobowe”</span></li>\n </ol>\n <b>Kontakt z inspektorem ochrony danych</b>\n <br>\n <br>\n Wyznaczyliśmy inspektora ochrony danych, z którym możesz się kontaktować we wszystkich sprawach związanych z przetwarzaniem\n przez nas Twoich danych osobowych. Możesz to zrobić wysyłając wiadomość na adres email: \n <a href=\"mailto:iod&#64;benefitsystems.pl\">iod&#64;benefitsystems.pl</a> lub listownie na adres: \n Benefit Systems S.A., Pl. Europejski 2, 00-844 Warszawa, z dopiskiem „IOD”."
        },
        {
          "heading": "Jakie dane osobowe przetwarzamy. Skąd je mamy",
          "link": "personal-data-1",
          "content": "Żeby prowadzić naszą działalnością przetwarzamy dane osobowe. <b>Dane osobowe</b> to informacje o zidentyfikowanej lub możliwej \n do zidentyfikowania osobie fizycznej (np.: imię i nazwisko, adres email, numer karty MultiSport, adres IP).\n <br>\n <br>\n Co do zasady, większość danych podajesz nam sam np. w trakcie kontaktu z nami lub kiedy korzystasz z naszych usług.\n <br>\n <br>\n To, jakie dane osobowe przetwarzamy, zależy od łączącej nas relacji (np.: klient, użytkownik serwisu internetowego, \n użytkownik karty MultiSport, partner).\n <br>\n <br>\n Gdy korzystasz <b>z naszych serwisów internetowych lub aplikacji</b> przetwarzamy dane podane przez Ciebie w formularzu rejestracyjnym i koncie, \n dane dotyczące Twojej aktywności w serwisie lub aplikacji (np. interakcji z treściami itp.) oraz dane dotyczące \n Twojego urządzenia (tj. adres IP, dane zebrane z wykorzystaniem plików cookies lub innych podobnych technologii, \n dane dotyczące przeglądarki, ID). Więcej na temat plików cookies znajdziesz w <a href=\"/polityka-cookies\">„Polityce cookies”</a>.\n <br>\n <br>\n Kiedy przystąpisz do <b>Programu MultiSport lub Programu MultiLife, korzystasz z naszej Kafeterii</b>, zawierasz z nami <b>umowę o karnet \n Klubu Fitness</b> lub <b>korzystasz z innych naszych usług</b> (np. BenefitLunch, MultiBilet, MultiTeatr) przetwarzamy Twoje dane jak na przykład \n dane identyfikacyjne, dane kontaktowe oraz dane dotyczące korzystania przez Ciebie z naszych usług (w tym z usług podmiotów z nami \n współpracujących oraz dostawców dodatkowych usług oferowanych w związku z Programem MultiSport, MultiLife, naszą Kafeterią, \n posiadaniem przez Ciebie karty członkowskiej naszego Klubu Fitness lub korzystaniem z innych naszych usług). Dane otrzymujemy \n bezpośrednio od Ciebie np. poprzez formularz rejestracyjny lub podczas podpisywania umowy w wybranym przez Ciebie Klubie Fitness \n lub na stronie internetowej Klubu. Twoje dane możemy również otrzymać od podmiotu, który umożliwił Ci korzystanie z Programu \n MultiSport, MultiLife, Kafeterii lub innych naszych usług oraz od dostawców dodatkowych usług i benefitów.\n <br>\n <br>\n Gdy łączą nas <b>relacje biznesowe</b> przetwarzamy Twoje dane, jak na przykład dane identyfikacyjne, dane kontaktowe, dane dotyczące \n pełnionej przez Ciebie funkcji oraz dane dot. współpracy, zamówień oraz rozliczeń. W przypadku, jeżeli jesteś stroną umowy, \n dane otrzymaliśmy bezpośrednio od Ciebie. W przypadku, jeżeli jesteś przedstawicielem lub osobą kontaktową podmiotu będącego \n stroną umowy zawartej z Benefit Systems, dane otrzymaliśmy od podmiotu będącego stroną umowy. Dane mogliśmy też otrzymać od \n podmiotu pośredniczącego w nawiązaniu współpracy z Tobą lub podmiotem, którego jesteś przedstawicielem lub osobą kontaktową.\n "
        },
        {
          "heading": "Jak przetwarzamy Twoje dane osobowe",
          "link": "personal-data-2",
          "content": "Sposób przetwarzania Twoich danych osobowych zależy od relacji, jaka łączy Cię z Benefit Systems. \n Poniżej znajdziesz informacje dotyczące celów, w jakich najczęściej przetwarzamy dane osobowe.\n <br>\n <br>\n Jeżeli poniżej nie znajdujesz opisu, który pasuje do łączącej nas relacji, a chcesz uzyskać dodatkowe informacje na temat przetwarzania \n przez nas Twoich danych, skontaktuj się z nami. Dane kontaktowe znajdziesz w punkcie <a href=\"#contact\">Jak się z nami skontaktować</a> powyżej.\n <br>\n <br>\n Może się zdarzyć, biorąc pod uwagę specyfikę korzystania przez Ciebie z naszych usług, że będziemy przetwarzać Twoje dane osobowe \n w inny sposób niż wskazany poniżej. W każdym takim przypadku powiadomimy Cię o tym przed rozpoczęciem takiego przetwarzania.\n <br>\n <br>\n <table>\n <tbody>\n <tr>\n <th>\n Cele przetwarzania:\n </th>\n <th>\n Podstawy prawne:\n </th>\n </tr>\n <tr>\n <td>\n Świadczenia usług w ramach naszych serwisów internetowych lub aplikacji mobilnych\n </td>\n <td>\n Realizacja umowy o świadczenie usług drogą elektroniczną zgodnie z regulaminem (art. 6 ust. 1 lit. b RODO)\n </td>\n </tr>\n <tr>\n <td>\n Administrowanie infrastrukturą oraz zapewnienie bezpieczeństwa infrastruktury oraz świadczonych usług\n </td>\n <td>\n Nasz prawnie uzasadniony interes polegający na administrowaniu i zapewnieniu bezpieczeństwa infrastruktury oraz usług (art. 6 ust. 1 lit. f RODO)\n </td>\n </tr>\n <tr>\n <td>\n Ułatwienie korzystania, prowadzenie statystyk oraz poprawianie i rozwój naszych usług, w tym serwisów i aplikacji\n </td>\n <td>\n Nasz prawnie uzasadniony interes polegający na dostosowywaniu, poprawieniu i rozwoju naszych usług (art. 6 ust. 1 lit. f RODO)\n </td>\n </tr>\n <tr>\n <td>\n Świadczenie usług lub dostarczanie dopasowanych treści marketingowych w ramach których wykorzystane są szczególne kategorie danych \n (np. dane dotyczące zdrowia)\n </td>\n <td>\n Twoja wyraźna zgoda (9 ust. 2 lit. a RODO)\n </td>\n </tr>\n <tr>\n <td>\n Pokazanie Ci w wyszukiwarce lub w aplikacji obiektów, które znajdują się najbliżej Twojej lokalizacji\n </td>\n <td>\n Nasz prawnie uzasadniony interes w ułatwieniu Ci znalezieniu obiektu, gdy wyrazisz zgodę na dostęp do danych o \n lokalizacji (art. 6 ust. 1 lit. f RODO)\n </td>\n </tr>\n <tr>\n <td>\n Przeprowadzenie konkursu lub loterii, w tym wyłonienie zwycięzcy, przekazanie nagród, publikacja danych osobowych zwycięzcy\n </td>\n <td>\n Nasz prawnie uzasadniony interes polegający na realizacji konkursu lub loterii (art. 6 ust. 1 lit f RODO)\n </td>\n </tr>\n <tr>\n <td>\n Prowadzenie naszych stron w social mediach\n </td>\n <td>\n Nasz prawnie uzasadniony interes polegający na promowaniu naszych usług, produktów (w tym przygotowywanych wspólnie z kontrahentami) \n oraz produktów i usług podmiotów trzecich, w tym spółek z Grupy Benefit Systems oraz prowadzeniu statystyk dot. korzystania ze stron \n (art. 6 ust. 1 lit f RODO)\n </td>\n </tr>\n <tr>\n <td>\n Świadczenie usług związanych z korzystaniem z Programu MultiSport lub MultiLife\n </td>\n <td>\n Twoja zgoda (art. 6 ust. 1 lit. a RODO)<br>\n wyrażona także poprzez Twoje wyraźne zgłoszenie do Programu bezpośrednio u nas lub u pracodawcy\n </td>\n </tr>\n <tr>\n <td>\n Świadczenie usług związanych z korzystaniem z Kafeterii i innych usług (np. BenefitLunch, MultiBilet, MultiTeatr)\n </td>\n <td>\n Realizacja umowy zawartej przez Ciebie z Benefit Systems (art. 6 ust. 1 lit. b RODO)\n Nasz prawnie uzasadniony interes polegający na dostarczaniu i rozliczaniu usług (art. 6 ust. 1 lit f RODO)\n </td>\n </tr>\n <tr>\n <td>\n Świadczenie usług związanych z korzystaniem przez Ciebie z naszego Klubu Fitness lub innych usług, gdy zawierasz z nami umowę\n </td>\n <td>\n Realizacja umowy zawartej przez Ciebie z Benefit Systems, np. umowy o świadczenie usług przez nasz Klub (art. 6 ust. 1 lit. b RODO)\n Twoja zgoda w zakresie przetwarzania Twojego wizerunku lub odcisku palca w celu zidentyfikowania Ciebie w czasie wejścia na teren naszego \n Klubu (art. 6 ust. 1 lit. a, art. 9 ust. 2 lit. a RODO)\n </td>\n </tr>\n <tr>\n <td>\n Prowadzenie marketingu\n </td>\n <td>\n Nasz prawnie uzasadniony interes (art. 6 ust. 1 lit. f RODO) polegający na promowaniu naszych produktów, usług oraz \n Benefit Systems, jak również produktów i usług podmiotów trzecich, w tym spółek z Grupy Benefit Systems\n </td>\n </tr>\n <tr>\n <td>\n Wyświetlania Ci reklam lub ofert, które mogą być dopasowane do Twoich zainteresowań, aktywności w serwisach i aplikacjach lub lokalizacji\n </td>\n <td>\n Nasz prawnie uzasadniony interes (art. 6 ust. 1 lit. f RODO) polegający na przedstawianiu Ci reklam i ofert, którem mogą \n być dopasowane, z uwagi na łączącą nas umowę, prowadzoną współpracę lub Twoją zgodą na użycie plików cookies i podobnych \n technologii lub informacji o Twojej lokalizacji dla celów marketingowych\n </td>\n </tr>\n <tr>\n <td>\n Dostarczanie Ci treści marketingowych, które mogą być dopasowane, za pomocą wybranego przez Ciebie kanału komunikacji \n (np. email, SMS/MMS, telefon) dotyczących naszych własnych produktów i usług oraz produktów oraz usług przygotowanych wspólnie \n z kontrahentami Benefit Systems, które są oferowane naszym użytkownikom i klientom jako dodatkowe benefity \n (np. usługi dietetyczne, trenerskie, edukacyjno-rozwojowe) lub produktów i usług podmiotów trzecich, w tym spółek z \n Grupy Benefit Systems. <a href=\"https://document.benefitsystems.pl/temp/fileadmin/benefitsystems/rodo/klienci-lista-podmiotow-20180220.pdf\">\n Listę podmiotów trzecich znajdziesz tutaj</a>.\n </td>\n <td>\n Nasz prawnie uzasadniony interes (art. 6 ust. 1 lit. f RODO) polegający na przedstawianiu Ci treści marketingowych, w tym \n treści dopasowanych do Ciebie na podstawie profilowania, w związku z Twoją zgodą na użycie w tym celu wybranego przez \n Ciebie kanału komunikacji\n </td>\n </tr>\n <tr>\n <td>\n Dostarczanie Ci treści marketingowych w relacjach biznesowych, dotyczących własnych produktów i usług Benefit Systems oraz \n produktów i usług przygotowanych wspólnie z kontrahentami Benefit Systems, które są Tobie oferowane jako dodatkowe benefity \n (np. usługi dietetyczne, trenerskie, edukacyjno-rozwojowe) lub produktów i usług podmiotów trzecich, w tym spółek z \n Grupy Benefit Systems. <a href=\"https://document.benefitsystems.pl/temp/fileadmin/benefitsystems/rodo/klienci-lista-podmiotow-20180220.pdf\">\n Listę podmiotów trzecich znajdziesz tutaj</a>.\n </td>\n <td>\n Twoja zgoda (art. 6 ust. 1 lit. a RODO) lub nasz prawnie uzasadniony interes (art. 6 ust. 1 lit. f RODO) polegający na \n przedstawianiu Ci treści marketingowych, w tym treści dopasowanych do Ciebie na podstawie profilowania, w związku z \n Twoją zgodą na użycie w tym celu wybranego przez Ciebie kanału komunikacji (w zależności od informacji przekazanych na etapie \n zbierania zgody)\n </td>\n </tr>\n <tr>\n <td>\n Prowadzenie analityki, statystyk marketingowych i badania zadowolenia z usług oraz profilowania, czyli wykorzystywania danych \n dotyczących Twoich zainteresowań w celu dostarczania Ci dopasowanych ofert i treści\n </td>\n <td>\n Nasz prawnie uzasadniony interes (art. 6 ust. 1 lit. f RODO) polegający na sprawdzaniu efektywności działań marketingowych, \n podnoszeniu jakości świadczonej przez nas obsługi użytkowników oraz udoskonalaniu dostępnych u nas produktów i usług. \n Twoja wyraźna zgoda w zakresie danych szczególnych kategorii (9 ust. 2 lit. a RODO)\n </td>\n </tr>\n <tr>\n <td>\n Realizacja umowy i prowadzenie współpracy z kontrahentami, klientami i partnerami\n </td>\n <td>\n Gdy jesteś stroną umowy zawartej z Benefit Systems przetwarzamy Twoje dane, ponieważ jest to niezbędne do jej realizacji (art. 6 ust. 1 lit. b RODO)\n Gdy jesteś przedstawicielem lub osobą kontaktową naszego kontrahenta działamy w oparciu o nasz prawnie uzasadniony interes \n polegający na możliwości prawidłowego zawarcia i wykonania umowy z naszym kontrahentem oraz prowadzenia współpracy (art. 6 ust. 1 lit. f RODO)\n </td>\n </tr>\n <tr>\n <td>\n Obsługa zgłoszonej przez Ciebie sprawy, w tym udzielenia odpowiedzi na postawione przez Ciebie pytanie lub rozpatrzenia \n zgłoszonej przez Ciebie skargi, poprawa jakości świadczonej obsługi\n </td>\n <td>\n Nasz prawnie uzasadniony interes (art. 6 ust. 1 lit. f RODO) polegający na obsłudze kierowanych do nas zapytań lub skarg oraz \n zapewnieniu najwyższej jakości obsługi.\n <br>\n Realizacja obowiązku prawnego (art. 6 ust. 1 lit. c RODO) nałożonego na nas przez przepis prawa (np. w sytuacji, gdy sprawa, \n z którą się do nas zwracasz stanowi żądanie realizacji praw przysługujących na gruncie RODO)\n </td>\n </tr>\n <tr>\n <td>\n Realizacja obowiązków wynikających z przepisów prawa, w szczególności podatkowych i rachunkowych\n </td>\n <td>\n Obowiązujące przepisy prawa (art. 6 ust. 1 lit. c RODO)\n </td>\n </tr>\n <tr>\n <td>\n Dochodzenie, ustalenie i obrony przed roszczeniami\n </td>\n <td>\n Nasz prawnie uzasadniony interes polegający na możliwości dochodzenia lub obrony przed roszczeniami (art. 6 ust. 1 lit. f RODO lub art. 9 ust. 2 lit. f RODO w przypadku szczególnych kategorii danych osobowych)\n </td>\n </tr>\n </tbody>\n </table>\n "
        },
        {
          "heading": "Jak długo przechowujemy Twoje dane osobowe",
          "link": "personal-data-3",
          "content": "Twoje dane przechowujemy przez okres niezbędny do realizacji celów przetwarzania opisanych w punkcie \n <a href=\"#personal-data-2\">Jak przetwarzamy Twoje dane osobowe</a> powyżej. Usuniemy je, gdy przestaną być potrzebne w ww. celach. \n Twoje dane przechowujemy, w szczególności:\n <ol>\n <li>\n W celu realizacji umowy i świadczenia usług do czasu wykonania umowy lub zakończenia świadczenia usług, a następnie przez \n okres niezbędny do skutecznego dochodzenia lub obrony przed roszczeniami, który zazwyczaj wynosi 3 lub 6 lat, \n ale w określonych przez prawo sytuacjach może być krótszy albo dłuższy;\n </li>\n <li>\n Gdy prawo nakłada na nas określone obowiązki, w szczególności obowiązki podatkowe i rachunkowe, będziemy przetwarzać dane \n niezbędne dla realizacji tych obowiązków przez okres wymagany przez prawo;\n </li>\n <li>\n Gdy przetwarzamy dane na podstawie zgody, będziemy je przetwarzać nie dłużej niż do czasu jej cofnięcia;\n </li>\n <li>\n Gdy przetwarzamy dane na podstawie uzasadnionego interesu, będziemy je przetwarzać nie dłużej niż do czasu skutecznego zgłoszenia \n sprzeciwu, chyba że wcześniej przestaną być niezbędne dla realizacji naszych uzasadnionych interesów.\n </li>\n </ol>\n "
        },
        {
          "heading": "Rekrutacja",
          "link": "recruitment",
          "content": "Informacje dotyczące przetwarzania przez nas danych osobowych kandydatów do pracy dostępne są pod adresem:\n <br>\n <br>\n <a href=\"https://benefitsystems.pl/o-nas/kariera/obowiazek-informacyjny-dla-kandydata/\">\n https://benefitsystems.pl/o-nas/kariera/obowiazek-informacyjny-dla-kandydata\n </a>\n "
        },
        {
          "heading": "Marketing",
          "link": "marketing",
          "content": "<b>Ogólne informacje</b>\n <br>\n <br>\n Sposób, w jaki przetwarzamy dane osobowe w celach marketingowych, zależy od rodzaju łączącej nas relacji (np. czy zarejestrowałeś się \n w naszym serwisie internetowym lub aplikacji mobilnej, czy jesteś naszym klientem lub kontrahentem) oraz od zgód, których nam udzieliłeś.\n <br>\n <br>\n Nasze działania marketingowe mogą obejmować wyświetlanie Ci reklam w serwisach lub aplikacjach, przedstawianie oferty lub reklamy \n za pomocą kanału komunikacji takiego jak np. email czy telefon (jeżeli wyrazisz zgodą na dostarczanie Ci przez nas treści \n marketingowych za pomocą wybranego przez Ciebie kanału komunikacji np. email, SMS/MMS, telefon, push), tradycyjne wysyłki \n marketingowe, prowadzenie analiz i statystyk na potrzeby marketingowe oraz badania zadowolenia z usług, w tym w drodze kontaktu \n poprzez wybrany przez Ciebie kanał komunikacji. Dla potrzeb marketingu możemy dokonywać również profilowania.\n <br>\n <br>\n Dopasowany marketing\n <br>\n <br>\n Twoje dane osobowe możemy przetwarzać w celu prowadzenia marketingu obejmującego profilowanie, w następujących przypadkach:\n <ol>\n <li>\n <span>Jeśli <b>zgodzisz się na zapisanie na Twoim urządzeniu plików cookies lub podobnych technologii</b>, to możemy wykorzystać informacje \n zebrane za pomocą tych technologii do dostarczania Ci reklam lub ofert dopasowanych do Twoich potencjalnych zainteresowań \n zidentyfikowanych na podstawie przeglądanych treści i aktywności. Przykładowo, jeśli przeglądasz strony dotyczące pakietów \n MultiSport będziemy mogli wyświetlić Ci reklamę MultiSport lub pozostałych naszych usług na innych stronach w Internecie i aplikacjach;\n </span>\n </li>\n <li>\n <span>\n <b>Jesteś zarejestrowanym użytkownikiem naszego serwisu lub aplikacji</b> i zalogujesz się na swoje konto, zebrane informacje \n o przeglądanych przez Ciebie treściach będziemy mogli powiązać z Tobą i wykorzystać dla celów profilowania, żeby lepiej \n dopasować do Ciebie naszą komunikację marketingową i ofertę;\n </span>\n </li>\n <li>\n <span>\n Jeżeli wyrazisz <b>zgodę na dostarczanie Ci przez nas treści marketingowych</b> za pomocą wybranego przez Ciebie kanału komunikacji\n </span>\n </li>\n <li>\n <span>\n Jeśli łączy nas <b>umowa lub prowadzimy współpracę</b>\n </span>\n </li>\n <li>\n <span>\n <b>Jeśli zgodzisz się na użycie przez nas informacji o lokalizacji Twojego urządzenia (np. smartfona)</b>, to będziemy mogli \n wyświetlić Ci reklamę lub ofertę dopasowaną do Twojej lokalizacji. Przykładowo, będziemy mogli wyświetlić Ci zaproszenie na \n event z okazji otwarcia w pobliżu naszego nowego klubu fitness;\n </span>\n </li>\n <li>\n <span>\n <b>W celu prowadzenia analiz i statystyk</b> dla naszych potrzeb marketingowych oraz badania zadowolenia z oferowanych przez nas \n usług w drodze kontaktu poprzez wybrany przez Ciebie kanał komunikacji.\n </span>\n </li>\n </ol>\n <br>\n <br>\n Możemy przedstawiać Ci także nieprofilowane reklamy i oferty.\n <br>\n <br>\n <b>Czym jest profilowanie dla potrzeb marketingowych?</b>\n <br>\n <br>\n Przetwarzanie przez nas Twoich danych osobowych dla celów marketingu bezpośredniego wiąże się z profilowaniem.\n <br>\n <br>\n Profilowanie polega na tym, że dzięki automatycznemu przetwarzaniu Twoich danych wyciągamy wnioski na temat Twoich potencjalnych \n zainteresowań i preferencji. Dzięki profilowaniu możemy jak najlepiej dopasować do Ciebie produkty, oferty i reklamy. \n W ramach profilowania możemy też łączyć ze sobą informacje, które zostawiasz nam podczas korzystania z naszych różnych \n produktów i usług, np. informacje które zostawisz odwiedzając nasz serwis lub aplikację, korzystając z Programu MultiSport lub \n MultiLife, z Kafeterii, z usług naszego Klubu Fitness.\n <br>\n <br>\n Do profilowania używamy narzędzi dostarczanych przez wyspecjalizowane podmioty trzecie. Więcej informacji o naszych partnerach, \n możliwości dostosowania preferencji reklamowych znajdziesz w <a href=\"/polityka-cookies\">„Polityce cookies”</a>. \n Dążymy do tego, żeby profilowanie wiązało się dla Ciebie z odczuwalną korzyścią, jaką jest przedstawianie Ci ofert, promocji i reklam, \n które możesz uznać za interesujące. Chcemy w ten sposób uniknąć przedstawiania Ci treści, które będą dla Ciebie nieadekwatne lub nieatrakcyjne. \n Przykład: jeśli ustalimy, że jesteś kobietą i w ramach Programu MultiSport regularnie korzystasz z zajęć tanecznych w określonej \n lokalizacji, będzie to dla nas sygnał, że mogą zainteresować się nowe zajęcia taneczne w Twojej ulubionej lokalizacji, ale \n prawdopodobnie nie interesują Cię oferty dotyczące sportów walki w innym, odległym mieście.\n <br>\n <br>\n <b>Nasz prawnie uzasadniony interes a Twoje interesy, prawa i wolności</b>\n <br>\n <br>\n Przetwarzamy Twoje danych osobowych dla celów marketingowych, w tym profilowania na podstawie naszego prawnie uzasadnionego interesu. \n Dlatego dokonaliśmy oceny, czy Twoje interesy, prawa i wolności (np. prawo do prywatności) nie przeważają nad naszym interesem. \n Z tej oceny wynika, że możemy przetwarzać Twoje dane osobowe we wskazany sposób, bo:\n <br>\n <br>\n <ol>\n <li>\n Przetwarzamy Twoje dane osobowe dla celów marketingowych tylko wtedy, gdy stwierdzamy, że możesz rozsądnie się tego spodziewać \n (np. jesteś użytkownikiem karty MultiSport lub karnetu Klubu Fitness, zarejestrujesz się w naszym serwisie lub aplikacji, \n wyrazisz zgodę na otrzymywanie od nas emaili marketingowych);\n </li>\n <li>\n Komunikaty marketingowe za pomocą emaili, SMS/MMS, telefonów kierujemy do Ciebie tylko za Twoją zgodą;\n </li>\n <li>\n Komunikację marketingową dotyczącą produktów lub usług podmiotów trzecich niezwiązanych z Benefit Systems kierujemy do \n Ciebie za pomocą emaili, SMS/MMS, telefonów tylko, gdy udzielisz na to odrębnej zgody;\n </li>\n <li>\n Umożliwiamy Ci łatwe zgłoszenie sprzeciwu wobec przetwarzania Twoich danych osobowych dla celów marketingu bezpośredniego i \n informujemy Cię o tym prawie;\n </li>\n <li>\n Profilowanie na potrzeby marketingowe jakie stosujemy nie wkracza w sposób nadmierny w Twoją prywatność. Skupiamy się na tym, \n jakie produkty lub usługi dostępne w naszej ofercie mogą być dla Ciebie interesujące. Nie chcemy dostarczać Ci treści, które \n możesz uznać za nieatrakcyjne. Nie podejmujemy wobec Ciebie na podstawie profilowania decyzji, które wywołują skutki prawne \n (np. odmowa zawarcia umowy) lub w podobny sposób istotnie na Ciebie wpływają;\n </li>\n <li>\n Stosujemy środki techniczne i organizacyjne, które w odpowiednim stopniu zabezpieczają Twoje dane osobowe.\n </li>\n </ol>\n "
        },
        {
          "heading": "Social media",
          "link": "social-media", 
          "content": "Możesz nas spotkać w mediach społecznościowych m. in. na Facebooku, Instagramie, LinkedIn. Każdy serwis społecznościowy informuje Ciebie w jaki sposób przetwarza Twoje dane podczas rejestracji, w ramach swoich regulaminów lub polityk prywatności. Nie mamy wglądu do wszystkich informacji o Tobie w takim zakresie, w jakim wspomniane serwisy. Natomiast jeżeli posiadasz konto w serwisie społecznościowym i obserwujesz nasze profile (m. in. MultiLife, MultiSport, Zdrofit, Fabryka Formy, Benefit Systems) lub wchodzisz z nami w interakcję (np. zostawiając lajki, serduszka, komentarze, bądź pisząc do nas bezpośrednio przy pomocy komunikatora danego serwisu), wówczas widzimy te informacje o Tobie, które zostały przez Ciebie podane w danym serwisie społecznościowym w kontakcie z nami, bądź dany serwis nam dostarczy np. w zakresie wyświetlenia reklamy lub naszego profilu (w zależności od Twoich ustawień prywatności w danym serwisie).<br>\n <br>\n <b>Nasze strony w serwisach społecznościowych</b>\n <br>\n <br>\n Tak jak informowaliśmy powyżej, to dany serwis społecznościowy będzie administratorem Twoich danych osobowych, które przetwarza zgodnie z informacją przedstawioną Tobie podczas rejestracji, np. na: <br><ol><li>LinkedIn (Polityka prywatności: <a href=\"https://www.linkedin.com/legal/privacy-policy#others\" target=\"_blank\">\n https://www.linkedin.com/legal/privacy-policy#others</a>\n Dodatek o współadministrowaniu <a href=\"https://www.linkedin.com/legal/l/page-joint-controller-addendum\" target=\"_blank\">https://www.linkedin.com/legal/l/page-joint-controller-addendum</a>)</li><li>Meta (Facebook; Instagram, Instagram threads) (Centrum ochrony prywatności Facebook: <a href=\"https://www.facebook.com/about/privacy\" target=\"_blank\">www.facebook.com/about/privacy</a> Zasady dotyczące danych Instagram: <a href=\"https://help.instagram.com/155833707900388\" target=\"_blank\">https://help.instagram.com/155833707900388</a>)</li>.</ol>\n Dopiero gdy wejdziesz w interakcję z naszym profilem znajdującym się w danym serwisie, wówczas możemy przetwarzać Twoje dane jako ich administrator, o czym informujemy Ciebie w klauzulach informacyjnych umieszczonych na poszczególnych serwisach społecznościowych. Dodatkowo z niektórymi serwisami społecznościowymi możemy pełnić rolę tzw. współadministratorów. Przykładowo w odniesieniu do przetwarzania danych w ramach prowadzonych przez nas stron na Facebook oraz Instagram na potrzeby statystyk razem z Meta Platforms Ireland Limited, Block J, Serpentine Avenue, Dublin 4, Irlandia  działamy jako współadministratorzy Twoich danych. Uzgodnienia dotyczące współadministrowania znajdziesz na stronie <a href=\"https://www.facebook.com/legal/controller_addendum\" target=\"_blank\">www.facebook.com/legal/controller_addendum</a>. Gdy korzystamy z produktów Meta, robimy to zgodnie z ich regulaminem. Więcej informacji o statystykach stron najdziesz na stronie <a href=\"https://www.facebook.com/legal/terms/information_about_page_insights_data\" target=\"_blank\">www.facebook.com/legal/terms/information_about_page_insights_data</a>.<br> Chcąc uzyskać szczegółowe informacje związane z przetwarzaniem danych na platformach społecznościowych, możesz również z nami się skontaktować. Dane kontaktowe znajdziesz powyżej w punkcie <a href=\"#contact\">Jak się z nami skontaktować</a>.<br>\n <br>\n<b>Wtyczki i kody portali społecznościowych</b><br>\n <br>\n Pamiętaj jeżeli rejestrujesz się i logujesz z wykorzystaniem zewnętrznych usług uwierzytelniających oferowanych przez Facebook, Google, Apple lub inne, to otrzymamy Twoje dane osobowe tj. w szczególności imię, nazwisko lub nazwa użytkownika, zdjęcie profilowe, ID, informacje dot. autoryzacji w danym serwisie. W zależności od Twoich ustawień prywatności we wskazanych usługach zewnętrznych, możemy otrzymać także inne dane. Przed skorzystaniem z tej usługi zapoznaj się z regulaminami oraz zasadami wykorzystywania danych przez serwis zewnętrzny.<br>\n<br>\n Dodatkowo zamieszczamy w naszych serwisach i aplikacjach przyciski i kody portali społecznościowych. Gdy za pomocą przycisku odsyłamy Cię na portal społecznościowy możesz np. polubić lub zacząć obserwować naszą stronę. Twoja aktywność i dane osobowe są wtedy przetwarzane również przez podmiot prowadzący ten portal i są wykorzystywane przez ten podmiot do jego celów  np. marketingowych. Twoja aktywność na stronach zawierających kody oraz Twoje dane osobowe są zbierane przez podmioty prowadzące portale społecznościowe, w szczególności w celach statystycznych i sprawdzenia czy jesteś zalogowanym użytkownikiem tego portalu oraz umożliwienia świadczenia usług (np. logowania za pomocą konta na portalu społecznościowym). Dane te są także dalej przetwarzane w innych celach określonych przez te podmioty. Dotyczy to wszystkich użytkowników naszych serwisów bez względu na to, czy są zarejestrowanymi użytkownikami tych portali społecznościowych.<br>\n<br>\nPrzetwarzamy i umożliwiamy portalom społecznościowym dostęp do wskazanych danych na podstawie naszego prawnie uzasadnionego interesu (art. 6 ust. 1 lit. f RODO). Polega on na umożliwieniu Ci dzielenia się interesującymi treściami w social mediach, ułatwieniu logowania oraz promocji naszej działalności oraz usług i produktów. Szczegółowe informacje o przetwarzaniu Twoich danych osobowych oraz sposób realizowania Twoich praw związanych z przetwarzaniem danych przez portal społecznościowy zostały opisane w polityce prywatności danego portalu. Prosimy zapoznaj się z nimi.<br>\n<br>\n"
        },
        {
          "heading": "Czy podanie danych jest obowiązkowe",
          "link": "providing-data",
          "content": "Co do zasady podanie danych osobowych nie jest Twoim obowiązkiem, ale może być niezbędne do skorzystania z usług \n świadczonych przez Benefit Systems np. do zawarcia z nami umowy, wzięcia udziału w naszym konkursie lub rozpatrzenia Twojej sprawy. \n Niepodanie danych może więc skutkować w niektórych przypadkach brakiem możliwości świadczenia przez nas usług lub podjęcia innych \n działań. Nasze formularze, przy pomocy których gromadzimy dane jednoznacznie wskazują na dane, których podanie jest niezbędne.\n "
        },
        {
          "heading": "Komu przekazujemy Twoje dane",
          "link": "disclose-data",
          "content": "Twoje dane osobowe mogą zostać przekazane następującym podmiotom: \n <a href=\"https://benefitsystems.pl/dla-inwestora/lad-korporacyjny/lista-spolek-grupy-kapitalowej-benefit-systems/\" target=\"_blank\">\n podmiotom z Grupy Benefit Systems</a>, podmiotom świadczącym \n usługi hostingu i utrzymania naszych serwisów internetowych i aplikacji, podmiotom świadczącym usługi teleinformatyczne i usługi w \n zakresie wsparcia i bezpieczeństwa IT, podmiotom świadczącym usługi przechowywania i niszczenia nośników danych, podmiotom oferującym \n dodatkowe usługi wobec usług jakie Ci świadczymy, Partnerom (obiekty sportowo-rekreacyjne, rozrywkowe, kulturalne, hotele, biura i \n pośrednicy turystyczni), podmiotom, które umożliwiły Ci korzystanie z Programu MultiSport, MultiLife, Kafeterii lub innych usług \n (przeważnie będzie to Twój pracodawca lub pracodawca osoby, która zgłosiła się do Programu MultiSport lub MultiLife), podmiotom \n drukującym karty, operatorom portali społecznościowych, operatorom płatności, podmiotom wspierającym nas w windykacji należności, \n podmiotom świadczącym usługi związane z obsługą naszych klientów i innych interesantów (np. kurierom) oraz wspierającym nasze \n działania marketingowe, doradcom prawnym i podmiotom prowadzącym audyty.\n <br>\n <br>\n Twoje dane mogą zostać przekazane także organom publicznym w przypadkach przewidzianych przez prawo."
        },
        {
          "heading": "Czy przekazujemy Twoje dane poza Europejski Obszar Gospodarczy",
          "link": "data-transfer",
          "content": "Co do zasady Twoje dane osobowe nie są przekazywane poza Europejski Obszar Gospodarczy (EOG). Niektórzy odbiorcy danych (np. dostawcy rozwiązań technologicznych) mogą je przetwarzać w państwach trzecich. Dokładamy należytych starań, żeby przekazywanie danych do tych podmiotów było zgodne z prawem i wdrożone zostały odpowiednie zabezpieczenia. Jeżeli w stosunku do danego państwa trzeciego nie została wydana przez Komisję Europejską decyzja stwierdzająca w tym państwie należyty poziom ochrony danych osobowych, zapewniamy by transfer danych był realizowany na podstawie innych, przewidzianych przez prawo środków ochrony, np. w oparciu o standardowe klauzule umowne lub kodeksy postępowania. Możesz się z nami skontaktować w celu uzyskania kopii przyjętych środków ochrony. Dane kontaktowe znajdziesz powyżej w punkcie <a href=\"#contact\">Jak się z nami skontaktować</a>"
        },
        {
          "heading": "Jakie masz prawa",
          "link": "data-rights",
          "content": "\n <ol>\n <li>\n <span>\n <b>Dostępu do Twoich danych osobowych</b>, uzyskania od nas informacji o ich przetwarzaniu, a także otrzymania od nas kopii Twoich danych;\n </span>\n </li>\n <li>\n <span>\n <b>Zaktualizowania Twoich danych osobowych</b> ich poprawienia, gdy są nieprawidłowe;\n </span>\n </li>\n <li>\n <span>\n <b>Wycofania zgody na przetwarzanie danych osobowych</b> w dowolnej chwili. Nie wpływa to na zgodność z prawem przetwarzania, \n którego dokonaliśmy na podstawie zgody przed jej wycofaniem;\n </span>\n </li>\n <li>\n <span>\n <b>Sprzeciwu wobec przetwarzania Twoich danych</b>, gdy przetwarzanie Twoich danych osobowych odbywa się na podstawie prawnie \n uzasadnionego interesu, a sprzeciw jest uzasadniony Twoją szczególną sytuację;\n </span>\n </li>\n <li>\n <span>\n <b>Sprzeciwu wobec przetwarzania Twoich danych na potrzeby marketingu bezpośredniego, w tym profilowania;</b>\n </span>\n </li>\n <li>\n <span>\n <b>Ograniczenia przetwarzania Twoich danych osobowych</b> jeśli: \n <br>\n (1) kwestionujesz prawidłowość Twoich danych (na okres pozwalający nam sprawdzić prawidłowość tych danych); \n <br>\n (2) przetwarzanie jest niezgodne z prawem, a Ty sprzeciwiasz się usunięciu Twoich danych i żądasz w zamian ograniczenia ich wykorzystywania; \n <br>\n (3) nie potrzebujemy już Twoich danych osobowych do naszych celów, ale dane te są potrzebne Tobie do ustalenia, dochodzenia lub obrony przed roszczeniami albo \n <br>\n (4) wnosisz sprzeciw wobec przetwarzania Twoich danych – do czasu stwierdzenia skuteczności tego sprzeciwu;\n </span>\n </li>\n <li>\n <span>\n <b>Przenoszenia Twoich danych osobowych</b> – w odniesieniu do przetwarzania Twoich danych na podstawie zgody lub umowy, \n przysługuje Ci prawo otrzymania od nas Twoich danych osobowych, dostarczonych nam przez Ciebie, w powszechnie używanym, \n możliwym do odczytu komputerowego formacie. Możesz także zażądać, żebyśmy przesłali Twoje dane do innego administratora, \n jednakże zrobimy to tylko jeśli takie przesłanie jest technicznie możliwe;\n </span>\n </li>\n <li>\n <span>\n <b>Usunięcia Twoich danych osobowych</b> – możesz zgłosić do nas żądanie usunięcia Twoich danych w następujących przypadkach: \n <br>\n (1) jeżeli Twoje dane nie będą już niezbędne do celów, dla których są przetwarzane; \n <br>\n (2) cofniesz zgodę, na której opiera się przetwarzanie i nie ma innej podstawy przetwarzania; \n <br>\n (3) wniesiesz skuteczny sprzeciw wobec przetwarzania; \n <br>\n (4) Twoje dane osobowe były przetwarzane niezgodnie z prawem; \n <br>\n (5) Twoje dane muszą zostać usunięte, gdyż nakazuje nam to prawo.\n </span>\n </li>\n </ol>\n <br>\n <br>\n Żeby skorzystać z powyższych praw, skontaktuj się z nami lub z naszym inspektorem ochrony danych. Dane kontaktowe znajdziesz \n powyżej w punkcie <a href=\"#contact\">Jak się z nami skontaktować</a>\n <br>\n <br>\n Twoje żądanie zrealizujemy w terminie miesiąca od jego otrzymania. Gdy będziemy potrzebować więcej czasu poinformujemy Cię o \n wydłużeniu realizacji żądania, jak i o jego przyczynach. Jeżeli Twoje żądanie będzie ewidentnie nieuzasadnione lub nadmierne możemy \n odmówić podjęcia działań.\n <br>\n <br>\n <b>Masz też prawo do wniesienia skargi do organu nadzorczego</b> zajmującego się ochroną danych osobowych, w państwie UE Twojego zwykłego \n pobytu, miejsca pracy lub miejsca popełnienia domniemanego naruszenia. W Polsce organem nadzorczym jest Prezes Urzędu Ochrony \n Danych Osobowych. Więcej informacji dotyczących zgłaszania skarg do Prezesa Urzędu Ochrony Danych Osobowych znajdziesz tutaj: \n <a href=\"https://uodo.gov.pl/pl/83/155\" target=\"_blank\">https://uodo.gov.pl/pl/83/155</a>\n "
        },
        {
          "heading": "Zmiany Polityki prywatności",
          "link": "amendments",
          "content": "Będziemy regularnie dokonywać przeglądu i aktualizacji niniejszej Polityki w związku ze zmianami w przepisach prawa oraz \n nowymi podejmowanymi przez nas działaniami dotyczącymi Twoich danych osobowych."
        },
        {
          "heading": "",
          "link": "",
          "content": "<a href=\"https://document.benefitsystems.pl/temp/fileadmin/benefitsystems/polityka-prywatnosci/polityka-prywatnosci-obowiazujaca-do-4-wrzesnia-2025r.pdf\" target=\"_blank\">Polityka prywatności obowiązująca do 4 września 2025 r.</a>"
        }
      ]
    },
    "data": {
      "header": "Spis treści",
      "subheader": "Jeżeli chcesz przejść do wybranej sekcji, kliknij w link poniżej:",
      "list": [
        {
          "heading": "Administrator danych",
          "link": "dataadmi",
          "content": "Administratorem Twoich danych osobowych jest Benefit Systems S.A. z siedzibą w Warszawie (dalej „my” lub „Benefit Systems”), Pl. Europejski 2, 00-844 Warszawa. Możesz się z nami skontaktować poprzez adres e-mail: daneosobowe@benefitsystems.pl lub pisemnie na adres: Pl. Europejski 2, 00-844 Warszawa, z dopiskiem „Dane osobowe”."
        },
        {
          "heading": "Inspektor ochrony danych",
          "link": "datains",
          "content": "Wyznaczyliśmy inspektora ochrony danych, z którym można się skontaktować we wszystkich sprawach związanych z przetwarzaniem danych osobowych oraz wykonywaniem praw przysługujących zgodnie z RODO. Z inspektorem można się skontaktować poprzez e-mail: iod@benefitsystems.pl lub pisemnie na adres: Pl. Europejski 2, 00-844 Warszawa, z dopiskiem „IOD”."
        },
        {
          "heading": "Jakie dane na Twój temat przetwarzamy i skąd je mamy?",
          "link": "datakinds",
          "content": "Zasadniczo Twoje dane osobowe pozyskujemy bezpośrednio od Ciebie. Przetwarzamy dane osobowe zawarte w przesłanym przez Ciebie zgłoszeniu rekrutacyjnym, dane podane przez Ciebie i inne dane zebrane w trakcie procesu rekrutacyjnego (tj. w trakcie spotkań rekrutacyjnych, testów kompetencyjnych). Możemy także przetwarzać dane osobowe uzyskane od agencji rekrutacyjnej, która Cię reprezentuje lub przekazane nam przez Twoich pracodawców (gdy wyrazisz zgodę na weryfikację referencji) oraz dane zawarte na publicznie dostępnych stronach internetowych o charakterze zawodowo - biznesowym np. Twoim profilu na Linkedin."
        },
        {
          "heading": "W jakim celu, na jakiej podstawie prawnej oraz przez jaki okres przetwarzamy Twoje dane osobowe?",
          "link": "datapurpose",
          "content": "<ol>\n<li> Jeżeli zatrudnienie ma nastąpić na podstawie umowy o pracę: Twoje dane osobowe wskazane w Kodeksie pracy lub w innych ustawach szczegółowych (według wymogów ogłoszenia) są przetwarzane w oparciu o przepisy prawa lub w celu podjęcia działań na Twoje żądanie przed zawarciem umowy (np. termin rozpoczęcia pracy, wynagrodzenie) (podstawa prawna – art. 6 ust. 1 lit. b i c RODO). Dane będą przetwarzane przez okres niezbędny do przeprowadzenia procesu rekrutacji na stanowisko o które się ubiegasz i wyłonienia kandydata, a następnie, na wypadek gdybyśmy musieli powtórzyć tę rekrutację. Nie będziemy przetwarzać Twoich danych w tych celach dłużej niż przez 12 miesięcy od otrzymania Twojego zgłoszenia do konkretnej rekrutacji.</li><li>Jeżeli zatrudnienie ma nastąpić na podstawie umowy cywilnej: Twoje dane osobowe, takie jak dane identyfikacyjne, dane kontaktowe, wykształcenie, kwalifikacje zawodowe i historia zatrudnienia, termin rozpoczęcia pracy, wynagrodzenie są przetwarzane w celu podjęcia działań na Twoje żądanie przed zawarciem umowy (podstawa prawna – art. 6 ust. 1 lit. b RODO). Dane będą przetwarzane przez okres niezbędny do przeprowadzenia procesu rekrutacji na stanowisko o które się ubiegasz i wyłonienia kandydata, a następnie, na wypadek gdybyśmy musieli powtórzyć tę rekrutację. Nie będziemy przetwarzać Twoich danych w tych celach dłużej niż przez 12 miesięcy od otrzymania Twojego zgłoszenia do konkretnej rekrutacji.</li><li>Twój adres email przetwarzamy na podstawie naszego uzasadnionego interesu polegającego na prowadzeniu i zarządzaniu rekrutacjami w systemie rekrutacyjnym. Z tego powodu, jeżeli decydujesz się do nas zaaplikować, wymagamy od Ciebie podania adresu email (podstawa prawna – art. 6 ust. 1 lit. f RODO). Dane będą przetwarzane przez okres niezbędny do przeprowadzenia procesu rekrutacji na stanowisko o które się ubiegasz i wyłonienia kandydata, a następnie, na wypadek gdybyśmy musieli powtórzyć tę rekrutację. Nie będziemy przetwarzać Twoich danych w tych celach dłużej niż przez 12 miesięcy od otrzymania Twojego zgłoszenia do konkretnej rekrutacji.</li><li>Dane dotyczące weryfikacji Twoich oświadczeń zawartych w zgłoszeniu i w trakcie procesu rekrutacyjnego, w szczególności Twoich kompetencji, w tym dane pozyskane w wyniku przeprowadzenia testów kompetencji (np. informacje o Twojej wiedzy i umiejętnościach), zebrane przez nas lub współpracującą z nami agencję rekrutacyjną, zebrane z Linkedin lub innych publicznie dostępnych stron internetowych o charakterze zawodowo – biznesowym przetwarzamy, w celu realizacji naszych uzasadnionych interesów (podstawa prawna – art. 6 ust. 1 lit. f RODO). Dane będą przetwarzane przez okres niezbędny do przeprowadzenia procesu rekrutacji na stanowisko o które się ubiegasz i wyłonienia kandydata, a następnie, na wypadek gdybyśmy musieli powtórzyć tę rekrutację. Nie będziemy przetwarzać Twoich danych w tych celach dłużej niż przez 12 miesięcy od otrzymania Twojego zgłoszenia do konkretnej rekrutacji.</li><li>Dane zawarte w referencjach od poprzednich pracodawców lub uzyskane podczas naszych rozmów z pracodawcami (np. dane dotyczące Twoich umiejętności), w oparciu o Twoją zgodę (podstawa prawna – art. 6 ust. 1 lit. a RODO). Dane będą przetwarzane przez okres niezbędny do przeprowadzenia rozmowy referencyjnej z osobą, która ich udzieliła. Nie będziemy przetwarzać Twoich danych w tych celach dłużej niż przez 30 dni od otrzymania referencji.</li><li>Dodatkowe dane, które zdecydujesz się nam przekazać dobrowolnie, np. wizerunek czy informacje o zainteresowaniach będziemy przetwarzać na podstawie Twojej zgody (podstawa prawna – art. 6 ust. 1 lit. a RODO). Dane będą przetwarzane przez okres niezbędny do przeprowadzenia procesu rekrutacji na stanowisko o które się ubiegasz i wyłonienia kandydata, a następnie, na wypadek gdybyśmy musieli powtórzyć tę rekrutację. Nie będziemy przetwarzać Twoich danych, w tych celach dłużej niż przez 12 miesięcy od otrzymania Twojego zgłoszenia do konkretnej rekrutacji.</li><li>W przypadku konieczności powtórzenia rekrutacji będziemy przetwarzać, w tym celu Twoje dane zebrane w związku z rekrutacją na podstawie uzasadnionego interesu (podstawa prawna – art. 6 ust. 1 lit. f RODO). Nie będziemy przetwarzać Twoich danych w tych celach dłużej niż przez 12 miesięcy od otrzymania Twojego zgłoszenia do konkretnej rekrutacji.</li><li>W przypadku, gdy w procesie Twojej rekrutacji udział bierze agencja rekrutacyjna przetwarzamy Twoje dane identyfikacyjne oraz informacje o Twoich oczekiwaniach finansowych lub wynagrodzeniu na podstawie uzasadnionego interesu w celu wykonania umowy z tą agencją (podstawa prawna – art. 6 ust. 1 lit. f RODO). Nie będziemy przetwarzać Twoich danych w tych celach dłużej niż przez 12 miesięcy od otrzymania Twojego zgłoszenia do konkretnej rekrutacji.</li><li>Przyszłe rekrutacje na stanowiska w Spółce odpowiadające Twoim kwalifikacjom na podstawie Twojej zgody (podstawa prawna – art. 6 ust. 1 lit. a RODO). Jeżeli brałeś lub weźmiesz udział w kilku rekrutacjach i wyrazisz zgodę, abyśmy zgromadzone dane wykorzystali również na potrzeby przyszłych rekrutacji, wówczas – prowadząc taką przyszłą rekrutację, możemy wykorzystać wszystkie dane zebrane o Tobie – o ile nie upłynął okres przetwarzania danych na podstawie wyrażonej zgody. Twoje dane będą przetwarzane w tym celu przez okres 24 miesięcy od wyrażenia zgody.</li><li>W sytuacji, gdy podmioty należące do grupy kapitałowej Benefit Systems (lista podmiotów: <a target='_blank' href='https://benefitsystems.pl/o-nas/lista-spolek-grupy-kapitalowej-benefit-systems'>www.benefitsystems.pl/o-nas/lista-spolek-grupy-kapitalowej-benefit-systems/</a>) prowadzą podobny proces rekrutacyjny do tego realizowanego w naszej spółce możemy przekazać im dane kandydatów z naszej bazy danych (podstawa prawna – art. 6 ust. 1 lit. a RODO). Możemy wykorzystać w tym celu wszystkie dane zebrane o Tobie – o ile nie upłynął okres przetwarzania danych na podstawie wyrażonej zgody. Twoje dane będą przetwarzane w tym celu przez okres 24 miesięcy od wyrażenia zgody. Podmioty, którym dane zostaną udostępnione staną się ich odrębnymi administratorami i będą przetwarzać Twoje dane według własnych zasad.</li><li>Wyjątkowo, w przypadku ewentualnych nieporozumień miedzy Tobą a Spółką, w celu dochodzenia roszczeń i obrony przed roszczeniami, na podstawie naszego uzasadnionego interesu (podstawa prawna – art. 6 ust. 1 lit. f RODO). Twoje dane będą przetwarzane zasadniczo przez okres 3 lat od zakończenia rekrutacji, a dłużej, jeśli wynika to z przepisów prawa.</li></ol>\nPodanie danych osobowych wskazanych w Kodeksie pracy lub innych przepisach prawa (jeżeli zostały wskazane w ogłoszeniu) jest obowiązkowe, żeby wziąć udział w danej rekrutacji. Podobnie podanie danych niezbędnych do podjęcia działań na Twoje żądanie przed zawarciem umowy oraz niezbędnych w naszym uzasadnionym interesie. Podanie pozostałych danych jest dobrowolne. Zasadniczo prosimy o nieprzekazywanie nam danych wrażliwych, o których mowa w art. 9 ust. 1 RODO, w tym danych o stanie zdrowia. Jeżeli jesteś osobą niepełnosprawną i uznasz, że poinformowanie nas o tym jest istotne dla procesu rekrutacyjnego, będziemy przetwarzać te dane w oparciu o przepisy prawa. W pozostałych sytuacjach, jeżeli decydujesz się przekazać nam dane wrażliwe, np. ze względu na Twoją szczególną sytuację, będziemy mogli je przetwarzać jedynie, gdy udzielisz wyraźnej zgody na przetwarzanie przez nas takich danych wrażliwych. Przekazanie takich danych jest dobrowolne."
        },
        {
          "heading": "Odbiorcy danych",
          "link": "datareceive",
          "content": "Twoje dane osobowe mogą zostać przekazane następującym podmiotom: podmiotom z grupy Benefit Systems (lista podmiotów: www.benefitsystems.pl/o-nas/lista-spolek-grupy-kapitalowej-benefit-systems/), podmiotom świadczącym usługi hostingu i utrzymania naszych serwisów internetowych i aplikacji, podmiotom świadczącym usługi teleinformatyczne i usługi w zakresie wsparcia i bezpieczeństwa IT, podmiotom świadczącym usługi przechowywania i niszczenia nośników danych, agencjom rekrutacyjnym, osobom udzielającym referencji, podmiotom świadczącym usługi związane z obsługą naszych klientów i innych interesantów (np. kurierom), doradcom prawnym i podmiotom prowadzącym audyty. Twoje dane mogą zostać przekazane także organom publicznym w przypadkach przewidzianych przez prawo."
        },
        {
          "heading": "Przekazywanie danych poza EOG",
          "link": "datasend",
          "content": "Co do zasady Twoje dane osobowe nie są przekazywane poza Europejski Obszar Gospodarczy (EOG). Niektóre podmioty, którym możemy przekazać dane mają siedzibę poza terytorium EOG. Dokładamy należytych starań, aby przekazywanie danych było zgodne z prawem i wdrożone zostały odpowiednie zabezpieczenia. Obejmuje to w szczególności stosowanie standardowych klauzul umownych zatwierdzonych przez Komisję. Możesz się z nami skontaktować w celu uzyskania kopii przyjętych środków ochrony. Dane kontaktowe znajdziesz w sekcji „administrator danych” lub „inspektor ochrony danych” powyżej."
        },
        {
          "heading": "Zautomatyzowane podejmowanie decyzji",
          "link": "dataauto",
          "content": "Nie podejmujemy wobec Ciebie decyzji opierających się wyłącznie na zautomatyzowanym przetwarzaniu informacji o Tobie, które wywoływałyby wobec Ciebie skutki prawne lub w podobny sposób istotnie na Ciebie wpływały."
        },
        {
          "heading": "Twoje prawa związane z przetwarzaniem danych osobowych",
          "link": "dataright",
          "content": "Masz następujące prawa związane z przetwarzaniem Twoich danych osobowych: prawo żądania dostępu do danych, prawo żądania sprostowania danych, prawo żądania usunięcia danych, prawo żądania ograniczenia przetwarzania, <u>prawo wniesienia sprzeciwu wobec przetwarzania</u>, prawo żądania przeniesienia podanych danych, prawo do wycofania zgody na przetwarzanie danych osobowych w dowolnym momencie. <br><br>Aby skorzystać z powyższych praw skontaktuj się z nami lub z naszym inspektorem ochrony danych. Dane kontaktowe znajdziesz powyżej. <br><br>Masz także prawo do wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych."
        }
      ]
    },
    "surveillance": {
      "header": "Spis treści",
      "subheader": "Jeżeli chcesz przejść do wybranej sekcji, kliknij w link poniżej:",
      "list": [
        {
          "heading": "Kto jest administratorem Twoich danych osobowych",
          "link": "admin",
          "content": "Administratorem Twoich danych osobowych jest Benefit Systems (Benefit Systems S.A. z siedzibą w Warszawie, Pl. Europejski 2, 00-844 Warszawa, dalej „Benefit Systems” lub „my”). Oznacza to, że Benefit Systems decyduje o celach i sposobach przetwarzania Twoich danych osobowych, czyli o tym, po co i w jaki sposób będą one wykorzystywane."
        },
        {
          "heading": "Jak się z nami skontaktować",
          "link": "contact",
          "content": "Z Benefit Systems można się skontaktować w następujący sposób:\n <ol>\n <li>przez e-mail: daneosobowe@fitness.benefitsystems.pl;  </li>\n <li>pisemnie na adres: Pl. Europejski 2, 00-844 Warszawa, z dopiskiem „Dane osobowe”; </li>\n <li>przez formularz: <a href=\"https://www.benefitsystems.pl/pomoc-i-obsluga/rodo/\">https://www.benefitsystems.pl/pomoc-i-obsluga/rodo/.<\/a>  </li>\n</ol>\n"
        },
        {
          "heading": "Czy powołaliśmy Inspektora Ochrony Danych Osobowych",
          "link": "inspector",
          "content": "Powołaliśmy Inspektora ochrony danych osobowych, możesz się z nim skontaktować w następujący sposób:\n <ol>\n <li>przez e-mail: iod@benefitsystems.pl;</li>\n <li>pisemnie na adres: Pl. Europejski 2, 00-844 Warszawa z dopiskiem „IOD”. </li>\n </ol>\n"
        },
        {
          "heading": "Jaki jest zakres zastosowania monitoringu wizyjnego ",
          "link": "area",
          "content": "Obszary i pomieszczenia objęte zastosowaniem monitoringu wizyjnego są odpowiednio oznaczone (np. symbolem kamery). W ramach prowadzonego monitoringu wizyjnego przetwarzamy dane osób znajdujących się w zasięgu zainstalowanych przez nas kamer. Dane te mogą obejmować przede wszystkim Twój wizerunek, jak też inne informacje, które mogą być zawarte w obrazie i nagraniach z monitoringu wizyjnego, takie jak informacje o cechach szczególnych lub określonym zachowaniu. <br><br>Rejestracji podlega obraz z kamer monitoringu bez rejestracji dźwięku. Monitoring nie obejmuje pomieszczeń sanitarnych oraz szatni. "
        },
        {
          "heading": "W jakim celu i na jakiej podstawie przetwarzamy Twoje danych osobowych  ",
          "link": "purpose",
          "content": "Twoje dane osobowe przetwarzamy w związku z prowadzonym monitoringiem wizyjnym w celu realizacji:\n <ol>\n <li>prawnie uzasadnionego interesu Benefit Systems (podstawa prawna art. 6 ust. 1 lit. f RODO), co dotyczy w szczególności: <br>\n <br>-\n zapewnienia bezpieczeństwa osób przebywających na terenie obiektu sportowego, <br>-\n ochrony mienia Benefit Systems oraz osób przebywających na terenie obiektu sportowego, <br>-\n ewentualnego ustalenia, dochodzenia lub obrony przed roszczeniami. <br>\n <br> &#8226;\n Oznacza to, że stosujemy monitoring wizyjny, aby wszystkie osoby przebywające w naszym obiekcie mogły czuć się bezpiecznie oraz aby miały pewność, że należycie dbamy o ich mienie. Chcemy także zapewniać Wam najlepszy sprzęt treningowy oraz atrakcyjną przestrzeń do ćwiczeń. Ten sprzęt oraz wyposażenie stanowią mienie, które dzięki zastosowaniu monitoringu możemy lepiej chronić, by móc zapewnić najwyższy standard usług.<br> &#8226;\n Gdy stwierdzimy, że w obiekcie doszło do kradzieży, zniszczenia mienia lub innej podobnej sytuacji, będziemy mogli skorzystać z nagrań pochodzących z monitoringu wizyjnego i dochodzić naszych praw. Jeśli coś nieprzyjemnego spotka Ciebie, będziemy mogli zabezpieczyć nagrania z monitoringu do czasu, gdy zawiadomisz odpowiednie organy. </li>\n <li>\n obowiązków wynikających z obowiązujących przepisów prawa (podstawa prawna art. 6 ust. 1 lit. c RODO), co dotyczy w szczególności: <br>\n <br>-\n udostępnienia danych osobowych zawartych w nagraniach do uprawnionych organów państwowych, na podstawie udokumentowanego i zgodnego z prawem żądania takiego organu, <br>-\n realizacji praw przysługujących Ci na gruncie RODO. <br><br> &#8226;\n Oznacza to, że jeśli Policja, Prokuratura lub inny uprawniony organ, w ramach prowadzonego postępowania, na podstawie odpowiednich przepisów, zażąda od nas przekazania określonych nagrań z monitoringu, będziemy musieli je udostępnić. Pamiętaj jednak, że to może leżeć w Twoim interesie. Takie nagrania mogą np. stanowić dowód kradzieży Twojej własności.  <br> &#8226;\n Oznacza to też, że jeśli będziesz chciał skorzystać z praw, które przysługują Ci w związku z przetwarzaniem danych osobowych, takich jak prawo dostępu do danych, będziemy musieli np. zabezpieczyć nagrania z monitoringu na których zostałeś zarejestrowany i udzielić Ci do nich wglądu. </li>\n  </ol>\n "
        },
        {
          "heading": "Jak długo przechowujemy Twoje dane osobowe ",
          "link": "time",
          "content": "Twoje dane osobowe przechowujemy przez okres niezbędny do realizacji celów przetwarzania, określonych w pkt. V „Cel i podstawa prawna przetwarzania danych osobowych” powyżej, jednak nie dłużej niż przez okres 1 miesiąca od ich utrwalenia. <br> <br>W przypadku, w którym nagrania z monitoringu wizyjnego stanowią dowód w postępowaniu prowadzonym na podstawie przepisów prawa lub Benefit Systems powziął wiadomość, iż mogą one stanowić dowód w postępowaniu, termin, o którym mowa powyżej, ulega przedłużeniu do czasu prawomocnego zakończenia postępowania. "
        },
        {
          "heading": "Kto jest odbiorcą Twoich danych osobowych ",
          "link": "who",
          "content": "Odbiorcami Twoich danych osobowych mogą być następujące podmioty: podmioty świadczące usługi teleinformatyczne oraz wsparcia i bezpieczeństwa IT, w szczególności podmioty świadczące usługi serwisu i utrzymania systemów informatycznych, w tym systemów monitoringu wizyjnego, podmioty świadczące usługi przechowywania i niszczenia nośników danych.<br> <br>Odbiorcami Twoich danych osobowych mogą być również doradcy prawni, podatkowi i podmioty prowadzące audyty jak też agencje/firmy ochroniarskie oraz organy publiczne, w przypadkach przewidzianych przez prawo. "
        },
        {
          "heading": "Jakie są Twoje prawa związane z przetwarzaniem danych osobowych   ",
          "link": "laws",
          "content": "W zakresie, w jakim podstawą przetwarzania Twoich danych osobowych jest nasz prawnie uzasadniony interes (art. 6 ust. 1 lit. f RODO), przysługuje Ci prawo do sprzeciwu wobec przetwarzania Twoich danych osobowych, z przyczyn związanych z Twoją szczególną sytuacją. <br><br> Masz też następujące prawa związane z przetwarzaniem Twoich danych osobowych:\n <br><br> &#8226;\n prawo dostępu do danych osobowych;  <br> &#8226;\n prawo żądania usunięcia Twoich danych osobowych; <br> &#8226;\n prawo do sprostowania danych osobowych; <br> &#8226;\n prawo żądania ograniczenia przetwarzania Twoich danych osobowych. <br><br> Aby skorzystać z powyższych praw, skontaktuj się z nami lub z naszym Inspektorem ochrony danych korzystając z danych kontaktowych podanych w pkt. II lub III powyżej.  <br><br>Przysługuje Ci także prawo wniesienia skargi do organu nadzorczego zajmującego się ochroną danych osobowych, tj. Prezesa Urzędu Ochrony Danych Osobowych, adres do korespondencji: ul. Stawki 2, 00-193 Warszawa. "
        },
        {
          "heading": "Czy podanie danych osobowych jest obowiązkowe ",
          "link": "obligations",
          "content": "Co do zasady podanie danych osobowych nie jest Twoim obowiązkiem, jednak korzystanie z obiektów objętych systemem monitoringu jest jednoznaczne z pozyskiwaniem Twoich danych osobowych, na zasadach opisanych w tej informacji dotyczącej przetwarzania danych osobowych. "
        },
        {
          "heading": "Czy przekazujemy Twoje dane osobowe poza EOG",
          "link": "yourdata",
          "content": "Co do zasady Twoje dane osobowe nie są przekazywane poza Europejski Obszar Gospodarczy (EOG). Niektóre podmioty, którym możemy przekazać dane, mogą je przetwarzać poza terytorium EOG. Dokładamy należytych starań, aby przekazywanie danych było zgodne z prawem i wdrożone zostały odpowiednie zabezpieczenia. Obejmuje to w szczególności stosowanie standardowych klauzul umownych zatwierdzonych przez Komisję. Możesz się z nami skontaktować w celu uzyskania kopii przyjętych środków ochrony. Dane kontaktowe znajdziesz w pkt. II lub III powyżej.  "
        },
        {
          "heading": "Dodatkowe Informacje ",
          "link": "additionalInfo",
          "content": "Więcej informacji na temat zasad przetwarzania danych osobowych przez Benefit Systems oraz przysługujących Ci praw, znajdziesz pod adresem internetowym <a href=\"https://www.benefitsystems.pl/polityka-prywatnosci\">https://www.benefitsystems.pl/polityka-prywatnosci</a>"
        }
      ]
    }
  }
  